<template>
  <div class="container">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/websites' }">概览</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/websites/list' }">站点管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ website.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="page-header">
      <el-page-header title="" @back="$router.push('/websites/list')" :content="domain"></el-page-header>
      <p class="text-medium website-status">
        <span class="green" v-if="website.status === 1"><i class="el-icon-success"></i> 正在运行</span>
        <span class="red" v-if="website.status === 0"><i class="el-icon-error"></i> 暂停访问</span>
      </p>
      <p class="text-medium website-status blue" v-show="languages[lang] !== undefined">
        <b>{{ languages[lang] }}站</b>
        <el-link class="blue text-small" @click="backToEnglishVersion()"
          v-show="lang !== 'en' && lang !== '' && lang !== null && lang !== undefined">返回英语站</el-link>
      </p>
    </div>
    <el-tabs type="border-card" v-model="activeName" @tab-click="tabClick">
      <el-tab-pane label="基本设置" name="basic">
        <div class="website-detail-box">
          <el-skeleton :loading="loading" animated :rows="15">
            <el-descriptions title="基础信息" :column="1" label-width="200px">
              <el-descriptions-item label="源站地址">
                <span>{{ website.access }}.web.together-win.com</span>
                <span class="action-icon" @click="copy(website.access + '.web.together-win.com')"><i
                    class="el-icon-copy-document"></i></span>
                <span class="action-icon" @click="view(website.access + '.web.together-win.com')"><i
                    class="el-icon-view"></i></span>
              </el-descriptions-item>
              <el-descriptions-item label="调试模式">
                <el-switch v-model="website.debug" active-color="#13ce66" inactive-color="#ccc" @change="store()">
                </el-switch>
              </el-descriptions-item>
              <el-descriptions-item label="站点类型">
                <span :class="website.type ? 'blue' : 'grey'">{{ website.type || '暂未选择' }}</span>
                <el-popover placement="right" trigger="click">
                  <el-radio-group v-model="website.type">
                    <el-radio label="中间体">中间体</el-radio>
                    <el-radio label="类型二">类型二</el-radio>
                    <el-radio label="类型三">类型三</el-radio>
                  </el-radio-group>
                  <el-button type="primary" @click="store()">确定</el-button>
                  <span class="action-icon blue" slot="reference"><i class="el-icon-edit"></i></span>
                </el-popover>
              </el-descriptions-item>
              <el-descriptions-item label="负责人"><span>{{ website.creator.name_cn }}</span></el-descriptions-item>
              <el-descriptions-item label="创建时间"><span>{{ website.created_at }}</span></el-descriptions-item>
              <el-descriptions-item label="主产品"><span>{{ website.main_product }}</span></el-descriptions-item>
              <el-descriptions-item label="主邮箱">
                <span>{{ website.main_email }}</span>
                <el-popover placement="right" trigger="click">
                  <el-input v-model="website.main_email" placeholder="请输入内容"></el-input>
                  <el-button type="primary" @click="store()">确定</el-button>
                  <span class="action-icon blue" slot="reference"><i class="el-icon-edit"></i></span>
                </el-popover>
              </el-descriptions-item>
              <el-descriptions-item label="邮箱轮换">
                <div v-if="website.turning_email_pool_info.details === ''">
                  <span class="grey">暂未设置</span>
                </div>
                <div v-else>
                  <span>{{ website.turning_email_pool_info.title }}</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span>{{
                    website.turning_email_pool_info.period }}天</span>
                </div>
                <el-link :underline="false">
                  <span class="blue" style="margin-left: 10px;">
                    <i class="el-icon-edit" @click="editTurningEmailPoolVisible = true"></i>
                  </span>
                </el-link>
                <el-link :underline="false">
                  <span class="red" style="margin-left: 10px;">
                    <i class="el-icon-delete" @click="deleteTurningEmailPool()"></i>
                  </span>
                </el-link>
              </el-descriptions-item>
              <el-descriptions-item label="副邮箱">
                <span>{{ website.deputy_email }}</span>
                <el-popover placement="right" trigger="click">
                  <el-input v-model="website.deputy_email" placeholder="请输入内容"></el-input>
                  <el-button type="primary" @click="store()">确定</el-button>
                  <span class="action-icon blue" slot="reference"><i class="el-icon-edit"></i></span>
                </el-popover>
              </el-descriptions-item>
              <!-- <el-descriptions-item label="建站规则">
                <span>{{ website.avoid_ai_type_show }}</span>
                <el-popover placement="right" trigger="click">
                  <el-select v-model="website.avoid_ai_type" filterable>
                    <el-option label="规则T" value="天工开物"></el-option>
                    <el-option label="规则M" value="梦溪笔谈"></el-option>
                    <el-option label="规则B" value="本草纲目"></el-option>
                    <el-option label="规则B1" value="本草纲目拾遗"></el-option>
                    <el-option label="规则S" value="山海经"></el-option>
                    <el-option label="规则K" value="开煤要法"></el-option>
                    <el-option label="规则Z" value="植物名实图考"></el-option>
                    <el-option label="规则U" value="无"></el-option>
                  </el-select>
                  <el-button type="primary" @click="store()">确定</el-button>
                  <span class="action-icon blue" slot="reference"><i class="el-icon-edit"></i></span>
                </el-popover>
              </el-descriptions-item> -->
              <el-descriptions-item label="权重值">
                <span>{{ website.authority_score || website.authority_score === 0 ? website.authority_score : '暂未设置'
                }}</span>
                <el-popover placement="right" trigger="click">
                  <el-input v-model="website.authority_score" placeholder="请输入内容" type="number" min="0" max="100"
                    step="1"></el-input>
                  <el-button type="primary" @click="store()">确定</el-button>
                  <span class="action-icon blue" slot="reference"><i class="el-icon-edit"></i></span>
                </el-popover>
              </el-descriptions-item>
            </el-descriptions>
            <el-link type="danger" @click="deleteWebsite()">删除此站</el-link>
            <el-link type="primary" @click="refreshCDN()">刷新CDN</el-link>
            <el-divider></el-divider>
            <el-descriptions title="联系人信息" :column="4" label-width="200px">
              <el-descriptions-item label="业务员">
                <span>{{ website.saler.saler }}</span>
                <el-popover placement="right" trigger="click">
                  <el-select v-model="website.saler_id" filterable>
                    <el-option v-for="item in salers" :key="item.id" :label="item.saler" :value="item.id">
                    </el-option>
                  </el-select>
                  <el-button type="primary" @click="store()">确定</el-button>
                  <span class="action-icon blue" slot="reference"><i class="el-icon-edit"></i>变更</span>
                  <!-- <span class="action-icon blue" slot="reference" @click="activeName = 'salers'"><i
                    class="el-icon-collection"></i>通讯录</span>-->
                </el-popover>
              </el-descriptions-item>
              <el-descriptions-item label="mobile"><span>{{ website.saler.mobile }}</span></el-descriptions-item>
              <el-descriptions-item label="telephone"><span>{{ website.saler.telephone }}</span></el-descriptions-item>
              <el-descriptions-item label="whatsapp"><span>{{ website.saler.whatsapp }}</span></el-descriptions-item>
              <el-descriptions-item label="instagram"><span>{{ website.saler.instagram }}</span></el-descriptions-item>
              <el-descriptions-item label="skype"><span>{{ website.saler.skype }}</span></el-descriptions-item>
              <el-descriptions-item label="facebook"><span>{{ website.saler.facebook }}</span></el-descriptions-item>
              <el-descriptions-item label="vk"><span>{{ website.saler.vk }}</span></el-descriptions-item>
              <el-descriptions-item label="telegram"><span>{{ website.saler.telegram }}</span></el-descriptions-item>
              <el-descriptions-item label="viber"><span>{{ website.saler.viber }}</span></el-descriptions-item>
              <el-descriptions-item label="address"><span>{{ website.saler.address }}</span></el-descriptions-item>
            </el-descriptions>
            <el-divider></el-divider>
          </el-skeleton>
        </div>
        <el-dialog title="编辑轮换邮箱" :visible.sync="editTurningEmailPoolVisible">
          <el-form label-width="100px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="标注">
                  <el-input v-model="website.turning_email_pool_info.title"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="周期(天)">
                  <el-input type="number" v-model="website.turning_email_pool_info.period" min="1"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="18">
                <el-form-item label="轮换池">
                  <el-input type="textarea" :rows="8" v-model="website.turning_email_pool_info.details"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="3">&nbsp;</el-col>
              <el-col :span="12">
                <i class="el-icon-warning-outline"></i>
                <i>一行一个, 此处不检测邮箱合法性, 请确保正确</i>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="editTurningEmailPoolVisible = false;">取 消</el-button>
            <el-button type="primary" @click="saveTurningEmailPool()">保 存</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="模版列表" name="blades" v-loading="bladesloading" :element-loading-text="bladesloadingText">
        <template>
          <el-button @click="pageSettings()" icon="el-icon-s-tools" circle title="主菜单设置"></el-button>
          <el-button @click="footerPageSettings()" icon="el-icon-setting" circle title="底部菜单设置"></el-button>
          <el-button @click="logoSettings()" icon="el-icon-picture-outline" circle title="Logo设置"></el-button>
          <el-button @click="colorSettings()" icon="el-icon-lollipop" circle title="颜色设置"></el-button>
        </template>
        <div class="website-detail-box-medium website-blades-box">
          <el-card v-for="item in bladesList" :key="item.id" :shadow="item.used ? 'always' : 'hover'">
            <img :src="item.cover" class="image">
            <div style="padding: 14px;">
              <span>{{ item.title }}</span>
              <div class="bottom clearfix">
                <el-button type="text" v-if="item.used" disabled>
                  <i class="el-icon-success green text-extra-large" v-if="item.used"></i>
                </el-button>
                <el-button type="text" v-else @click="useBlade(item)">应用</el-button>
              </div>
            </div>
          </el-card>
        </div>
        <el-dialog title="LOGO设置" :visible.sync="logoSettingsVisible" width="40%">
          <el-descriptions border>
            <el-descriptions-item label="本模板logo尺寸">{{ logoInfo.logo_width }} ×
              {{ logoInfo.logo_height }}</el-descriptions-item>
            <el-descriptions-item label="需要白色logo">
              <i class="el-icon-check blue" v-if="logoInfo.need_white"></i>
              <i class="el-icon-close red" v-if="logoInfo.need_white === false"></i>
              <!-- <i class="el-icon-close red" v-else></i> -->
            </el-descriptions-item>
          </el-descriptions>
          <br>
          <h4>当前logo效果</h4>
          <br>
          <div class="logo-setting-current-box">
            <div class="block">
              <el-image :style="'width: ' + logoInfo.show_width + 'px; height: ' + logoInfo.show_height + 'px'"
                :src="logoInfo.logo + '?' + new Date().getTime()" v-if="logoInfo.logo"></el-image>
              <span class="red" v-else>未检测到文件</span>
              <span class="demonstration">主logo</span>
            </div>
            <div class="block">
              <el-image
                :style="'width: ' + logoInfo.show_width + 'px; height: ' + logoInfo.show_height + 'px; background: rgba(0,0,0,0.1)'"
                :src="logoInfo.logo_white + '?' + new Date().getTime()" v-if="logoInfo.logo_white"></el-image>
              <span class="red" v-else>未检测到文件</span>
              <span class="demonstration">白</span>
            </div>
            <div class="block">
              <el-image style="width: 24px; height: 24px;" :src="logoInfo.fav + '?' + new Date().getTime()"
                v-if="logoInfo.fav"></el-image>
              <span class="red" v-else>未检测到文件</span>
              <span class="demonstration">小图标</span>
            </div>
          </div>
          <br>
          <h4>重新上传</h4>
          <br>
          <div class="logo-upload-box">
            <el-upload class="upload-button"
              :action="this.$axios.defaults.baseURL + `websites/backend/logo/upload?type=logo&domain=${domain}`"
              :headers="headersObj" :limit="1" :on-success="uploadLogoSuccess">
              <el-button type="text">主logo</el-button>
            </el-upload>
            <el-upload class="upload-button"
              :action="this.$axios.defaults.baseURL + `websites/backend/logo/upload?type=logo_white&domain=${domain}`"
              :headers="headersObj" :limit="1" :on-success="uploadLogoSuccess">
              <el-button type="text">白色logo</el-button>
            </el-upload>
            <el-upload class="upload-button"
              :action="this.$axios.defaults.baseURL + `websites/backend/logo/upload?type=favicon&domain=${domain}`"
              :headers="headersObj" :limit="1" :on-success="uploadLogoSuccess">
              <el-button type="text">小图标</el-button>
            </el-upload>
          </div>
        </el-dialog>

        <el-dialog title="颜色设置" :visible.sync="colorSettingsVisible" width="40%">
          <el-form :model="siteColors" label-width="120px">
            <el-row>
              <i class="el-icon-info grey"> <i> 颜色编码采用十六进制, 即0~9 A~F, 大小写不限</i></i>
            </el-row>
            <br>
            <el-row>
              <el-col :span="18">
                <el-form-item label="第一色">
                  <div style="display: flex; align-items: center; justify-content: space-around;">
                    <el-color-picker v-model="siteColors.first"></el-color-picker>
                    <i class="el-icon-info" :style="'color: ' + siteColors.first"> 网站主要颜色</i>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="18">
                <el-form-item label="第二色">
                  <div style="display: flex; align-items: center; justify-content: space-around;">
                    <el-color-picker v-model="siteColors.second"></el-color-picker>
                    <i class="el-icon-info" :style="'color: ' + siteColors.second"> 网站次要颜色</i>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="18">
                <el-form-item label="第三色">
                  <div style="display: flex; align-items: center; justify-content: space-around;">
                    <el-color-picker v-model="siteColors.third"></el-color-picker>
                    <i class="el-icon-info" :style="'color: ' + siteColors.third"> 网站辅助颜色</i>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="colorSettingsVisible = false">关 闭</el-button>
            <el-button @click="saveColorSettings">保 存</el-button>
          </span>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="栏目页管理" name="pages">
        <el-row>
          <el-button @click="pageSettings()" icon="el-icon-s-tools" circle title="主菜单设置"></el-button>
          <el-button @click="footerPageSettings()" icon="el-icon-setting" circle title="底部菜单设置"></el-button>
        </el-row>
        <br>
        <el-table :data="pagesList" border style="width: 100%" height="565" v-loading="pagesLoading">
          <el-table-column prop="title" label="栏目">
            <template v-slot="scope">
              <span v-if="scope.row.parent_id > 0">——&nbsp;&nbsp;&nbsp;&nbsp;</span><span>{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="90">
            <template v-slot="scope">
              <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ccc"
                @change="togglePagesStatus(scope.row, scope.$index)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="meta" label="metas" width="450">
            <template #header>
              <span>metas</span>
              <el-tooltip content="标蓝的表示已经人工编写" placement="right" effect="light">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template v-slot="scope">
              <el-tooltip :content="scope.row.title_suffix" placement="top" effect="light"
                v-if="scope.row.title_suffix">
                <el-tag>title</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>title</el-tag>
              <el-tooltip :content="scope.row.keywords" placement="top" effect="light" v-if="scope.row.keywords">
                <el-tag>keywords</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>keywords</el-tag>
              <el-tooltip :content="scope.row.description" placement="top" effect="light" v-if="scope.row.description">
                <el-tag>description</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>description</el-tag>
              <el-tooltip :content="scope.row.og_title" placement="top" effect="light" v-if="scope.row.og_title">
                <el-tag>og_title</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>og_title</el-tag>
              <el-tooltip :content="scope.row.og_description" placement="top" effect="light"
                v-if="scope.row.og_description">
                <el-tag>og_description</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>og_description</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="需要文本" width="100">
            <template v-slot="scope">
              <i :class="scope.row.words > 0 ? 'blue el-icon-check' : 'red el-icon-close'"></i>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template v-slot="scope">
              <el-link type="primary" :underline="false" @click="editPage(scope.row)" class="text-small">编辑</el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog :title="pagesDetailTitle" :visible.sync="pagesDetailVisible" width="60%" style="margin-top: -60px;">
          <el-form :model="pagesDetailForm" label-width="110px" :rules="newsDetailRules" ref="pagesDetailForm"
            v-loading="pagesDetailLoading" :element-loading-text="pagesDetailLoadingText">
            <el-form-item label="title">
              <el-input v-model="pagesDetailForm.title_suffix"></el-input>
            </el-form-item>
            <el-form-item label="keywords">
              <el-input v-model="pagesDetailForm.keywords"></el-input>
            </el-form-item>
            <el-form-item label="description">
              <el-input v-model="pagesDetailForm.description"></el-input>
            </el-form-item>
            <el-form-item label="og_title">
              <el-input v-model="pagesDetailForm.og_title"></el-input>
            </el-form-item>
            <el-form-item label="og_description">
              <el-input v-model="pagesDetailForm.og_description"></el-input>
            </el-form-item>
            <el-form-item label="正文" prop="content">
              <el-col :span="24">
                <div class="editor-box">
                  <quill-editor v-model="pagesDetailForm.content" ref="pagesDetailContentEditor"
                    :optinotallow="editorOption">
                  </quill-editor>
                </div>
              </el-col>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="pagesDetailVisible = false">关 闭</el-button>
            <el-button @click="savePagesDetail">保 存</el-button>
          </span>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="媒体资源" name="media">
        <template>
          <el-radio v-model="mediaType" label="images" @change="mediaType = 'images'; getMedia()">图片</el-radio>
          <el-radio v-model="mediaType" label="videos" @change="mediaType = 'videos'; getMedia()">视频</el-radio>
          <el-button icon="el-icon-upload2" circle title="上传"
            @click="uploadMediaList = []; uploadMediaVisible = true"></el-button>
        </template>
        <div class="website-detail-box-medium website-media-image-box" v-loading="medialoading">
          <div v-if="mediaType === 'images'">
            <div class="media-image-box" v-for="(item, index) in mediaList" :key="index">
              <el-image :src="item.url" :preview-src-list="[item.url]" fit="contain" lazy :title="item.name"></el-image>
              <span class="text-small media-image-title">{{ item.name }}</span>
              <el-popover placement="right" trigger="click" class="image-rename-btn">
                <div style="display: flex;">
                  <el-input v-model="renamedMediaName" :placeholder="item.name"></el-input>
                  &nbsp;
                  <el-button type="primary" @click="storeRenameMedia(index, 'images')">确定</el-button>
                </div>
                <span slot="reference" title="重命名"><i class="el-icon-edit"></i></span>
              </el-popover>
              <i class="el-icon-delete image-delete-btn" title="删除" @click="deleteMedia(item.name, 'images')"></i>
            </div>
          </div>
          <div v-if="mediaType === 'videos'">
            <video v-for="(item, index) in mediaList" :key="index" :src="item.url" controls loading="lazy"></video>
          </div>
        </div>
        <el-dialog title="上传媒体文件" :visible.sync="uploadMediaVisible">
          <el-upload class="upload-demo" ref="uploadMedia"
            :action="this.$axios.defaults.baseURL + `websites/backend/media/upload?domain=${domain}&type=${mediaType}`"
            :file-list="uploadMediaList" :auto-upload="false" :multiple="true">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">确定上传</el-button>
            <div slot="tip" class="el-upload__tip">选取文件后, 点击确定上传</div>
          </el-upload>
          <div slot="footer" class="dialog-footer">
            <el-button @click="uploadMediaVisible = false; uploadMediaList = []; getMedia()">完 成</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="产品列表" name="products">
        <el-row>
          <el-input v-model="productsKeywords" placeholder="请输入关键字" clearable style="width: 300px; margin-right: 10px;"
            @clear="queryProductsList(true)"></el-input>
          <el-button @click="queryProductsList(true)" icon="el-icon-search" circle title="查询"></el-button>
          <el-button @click="addProduct()" icon="el-icon-plus" circle title="新增"></el-button>
          <el-button @click="uploadProducts()" icon="el-icon-upload2" circle title="批量上传"></el-button>
          <el-button @click="downloadProductsLinks()" icon="el-icon-download" circle title="下载产品链接"></el-button>
          <el-button @click="manageProductsCategories()" icon="el-icon-set-up" circle title="分类管理"></el-button>
          <el-button @click="redoProductPackages()" icon="el-icon-lollipop" circle type="primary"
            title="图片重制"></el-button>
          <el-button @click="clearProducts()" icon="el-icon-delete" type="danger" circle title="清空产品"></el-button>
        </el-row>
        <br>
        <el-table :data="productsList" border style="width: 100%" height="565" v-loading="productsLoading">
          <el-table-column prop="product_name" label="产品" width="400"></el-table-column>
          <el-table-column prop="cas" label="CAS" width="120"></el-table-column>
          <el-table-column prop="category" label="类级"></el-table-column>
          <el-table-column prop="status" label="状态" width="70">
            <template v-slot="scope">
              <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ccc"
                @change="toggleProductStatus(scope.row, scope.$index)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="meta" label="metas" width="400">
            <template #header>
              <span>metas</span>
              <el-tooltip content="标蓝的表示已经人工编写" placement="right" effect="light">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template v-slot="scope">
              <el-tooltip :content="scope.row.title_suffix" placement="top" effect="light"
                v-if="scope.row.title_suffix">
                <el-tag>title</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>title</el-tag>
              <el-tooltip :content="scope.row.keywords" placement="top" effect="light" v-if="scope.row.keywords">
                <el-tag>keywords</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>keywords</el-tag>
              <el-tooltip :content="scope.row.description" placement="top" effect="light" v-if="scope.row.description">
                <el-tag>description</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>description</el-tag>
              <el-tooltip :content="scope.row.og_title" placement="top" effect="light" v-if="scope.row.og_title">
                <el-tag>og_title</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>og_title</el-tag>
              <el-tooltip :content="scope.row.og_description" placement="top" effect="light"
                v-if="scope.row.og_description">
                <el-tag>og_description</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>og_description</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="properties" label="属性" width="80">
            <template v-slot="scope">
              <i :class="scope.row.properties ? 'blue el-icon-check' : 'red el-icon-close'"></i>
            </template>
          </el-table-column>
          <el-table-column prop="faq" label="文本" width="80">
            <template v-slot="scope">
              <i :class="scope.row.faq ? 'blue el-icon-check' : 'red el-icon-close'"></i>
            </template>
          </el-table-column>
          <el-table-column prop="has_cover" label="配图" width="120">
            <template #header>
              <span>配图</span>
              <el-tooltip content="如果不写, 则会使用产品名作为默认值" placement="top" effect="light">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template v-slot="scope">
              <i :class="scope.row.has_cover ? 'blue el-icon-check' : 'red el-icon-close'"></i>
              <el-tooltip :content="scope.row.cover_title" placement="top" effect="light" v-if="scope.row.cover_title">
                <el-tag>title</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>title</el-tag>
              <el-tooltip :content="scope.row.cover_alt" placement="top" effect="light" v-if="scope.row.cover_alt">
                <el-tag>alt</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>alt</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template v-slot="scope">
              <el-link type="primary" :underline="false" @click="getProductDetail(scope.row)"
                class="text-small">编辑</el-link>
              <el-link type="danger" :underline="false" @click="deleteProduct(scope.row)"
                class="text-small">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="productsTotal"
            @size-change="changeProductsSize" @current-change="currentProductsChange" :page-sizes="[10, 20, 50, 100]"
            :page-size="productsSize">
          </el-pagination>
        </div>
        <el-dialog :title="productDetailDiaTitle" :visible.sync="productDetailVisible" style="margin-top: -80px;"
          class="product-detail-modal">
          <el-form :model="productDetail" label-width="120px" :rules="productDetailRules" ref="productDetail"
            v-loading="productDetailLoading" :element-loading-text="productDetailLoadingText">
            <el-row>
              <el-col :span="12">
                <el-form-item label="产品">
                  <el-input placeholder="产品名" v-model="productDetail.product"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="CAS">
                  <el-input v-model="productDetail.cas"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="所属分类">
                  <el-select v-model="productDetail.category_id">
                    <el-option v-for="item in productCategoriesOptions" :key="item.id" :label="item.category"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="类型">
                  <el-select v-model="productDetail.type" clearable>
                    <el-option label="general" value="general"></el-option>
                    <el-option label="custom" value="custom"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item label="url">
                  <el-input placeholder="暴露的真实访问链接(不含.html), 若为空, 则由系统自动生成" v-model="productDetail.url"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="配图">
                  <el-image style="width: 120px; height: 120px; position: relative;" :src="productDetail.cover_src"
                    fit="fill">
                    <template #error>
                      <div class="image-error">未检测到配图</div>
                    </template>
                  </el-image>
                  <el-upload class="upload-demo" ref="uploadProducts"
                    :action="this.$axios.defaults.baseURL + `websites/backend/media/upload?domain=${domain}&type=images`"
                    :headers="headersObj" :multiple="false" :show-file-list="false"
                    :on-success="updateProductDetailImage">
                    <el-link type="primary" :underline="false">替换</el-link>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="文件名">
                  <el-input placeholder="如果为空, 则会使用初始默认名" v-model="productDetail.cover"></el-input>
                </el-form-item>
                <el-form-item label="title">
                  <el-input placeholder="title" v-model="productDetail.cover_title"></el-input>
                </el-form-item>
                <el-form-item label="alt">
                  <el-input placeholder="alt" v-model="productDetail.cover_alt"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <h3>Metas<small>(如果为空 则应用通用模板)</small></h3>
            <br>
            <el-row>
              <el-col :span="24">
                <el-form-item label="title">
                  <el-input v-model="productDetail.title_suffix"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="keywords">
                  <el-input v-model="productDetail.keywords"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="description">
                  <el-input v-model="productDetail.description"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="og_title">
                  <el-input v-model="productDetail.og_title"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="og_description">
                  <el-input v-model="productDetail.og_description"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <h3>Specifications<small>(请确保键值对应, 键会自动首字母大写, 值会保留输入格式)</small></h3>
            <br>
            <el-descriptions class="margin-top" :column="1" size="medium" border>
              <el-descriptions-item v-for="(item, index) in productDetail.properties" :key="index">
                <template slot="label">
                  <el-input v-model="item.property_key"></el-input>
                </template>
                <div style="display: flex; justify-content: space-between; align-items: center;">
                  <span><el-input v-model="item.property_value"></el-input></span>
                  <i class="el-icon-close pointer" @click="removeProperty(index)"></i>
                </div>
              </el-descriptions-item>
            </el-descriptions>
            <br>
            <i class="el-icon-plus pointer" @click="addProperty()"> 添加属性</i>
            <br>
            <br>
            <h3>Packing & Storage</h3>
            <br>
            <el-row class="mb-3">
              <el-col :span="6">
                Packing
              </el-col>
              <el-col :span="18">
                <el-input type="textarea" :rows="4" v-model="productDetail.packing_storage.packing"></el-input>
              </el-col>
              <el-col :span="6">
                Storage
              </el-col>
              <el-col :span="18">
                <el-input type="textarea" :rows="4" v-model="productDetail.packing_storage.storage"></el-input>
              </el-col>
              <el-col :span="6">
                Shipping
              </el-col>
              <el-col :span="18">
                <el-input type="textarea" :rows="4" v-model="productDetail.packing_storage.shipping"></el-input>
              </el-col>
            </el-row>
            <br>
            <h3>General Information<small>(此处栏目固定)</small></h3>
            <br>
            <el-row v-for="(item, index) in productDetail.generals" :key="item.id || index" class="mb-3">
              <el-col :span="6">
                {{ item.keywords_en }}
              </el-col>
              <el-col :span="18">
                <el-input type="textarea" :rows="8" v-model="item.en"></el-input>
              </el-col>
            </el-row>
            <br>
            <h3>Frequently Asked Questions</h3>
            <br>
            <div v-for="(item, index) in productDetail.faqs" :key="item.id || index">
              <el-row class="mb-3">
                <el-col :span="24">
                  <el-input v-model="item.question_en"></el-input>
                </el-col>
                <el-col :span="24">
                  <el-input type="textarea" :rows="15" v-model="item.human_content"></el-input>
                </el-col>
              </el-row>
              <br>
            </div>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveProductDetail()">保存</el-button>
            <el-button @click="productDetailVisible = false">取消</el-button>
          </div>
        </el-dialog>
        <el-dialog title="批量上传产品" :visible.sync="uploadProductsVisible" style="margin-top: -80px;">
          <el-form v-loading="uploadProductsLoading" label-width="100px">
            <el-descriptions>
              <el-descriptions-item label="当前操作站点"><b class="red">{{ domain }}</b></el-descriptions-item>
            </el-descriptions>
            <el-row>
              <el-col :span="24">
                <el-form-item label="选择文件">
                  <el-upload class="upload-demo" ref="uploadProducts"
                    :action="this.$axios.defaults.baseURL + `websites/backend/products/upload?domain=${domain}`"
                    :headers="headersObj" :file-list="uploadProductsFileList" :auto-upload="false" :limit="1"
                    :on-success="uploadProductsSuccess">
                    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="">
                  <i class="el-icon-warning"></i>
                  <i>请再次确认产品与站点的所属关系</i>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="uploadProductsVisible = false; uploadProductsFileList = []">取 消</el-button>
            <el-button type="primary" @click="submitUploadProducts">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="分类管理" :visible.sync="manageProductsCategoriesVisible" width="40%">
          <el-form :inline="true" :model="productCategoriesForm" class="demo-form-inline">
            <el-form-item label="新增分类">
              <el-input v-model="productCategoriesForm.category" placeholder="分类名"></el-input>
            </el-form-item>
            <el-form-item label="上级分类">
              <el-select v-model="productCategoriesForm.parent_id" placeholder="上一级" clearable>
                <el-option v-for="item in productCategoriesOptions" :key="item.id" :label="item.category"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="saveAddProductCategories">保 存</el-button>
            </el-form-item>
          </el-form>
          <template>
            <div v-loading="productCategoriesLoading">
              <el-tree :data="productCategoriesData" highlight-current node-key="id" :props="{
                children: 'children',
                label: 'category'
              }" ref="productCategoriesData" draggable @node-drag-end="handleDragEnd">
                <span class="custom-tree-node" slot-scope="{ node, data }" @dblclick="headerDbClick(data)"
                  @mouseenter="handleMouseEnter(data.id)" @mouseleave="handleMouseLeave">
                  <template>
                    <i class="el-icon-box" @click="setCategoryPackage(data, '包装')"
                      :title="data.package_type !== null ? data.package_type : '设置包装'"
                      :class="data.package_type !== null ? 'green' : 'grey'" v-if="data.children.length === 0"></i>
                    <i class="el-icon-pie-chart" @click="setCategoryPackage(data, '小样')"
                      :title="data.sample_type !== null ? data.sample_type : '设置小样'"
                      :class="data.sample_type !== null ? 'green' : 'grey'" v-if="data.children.length === 0"></i>
                  </template>
                  <span v-if="!data.isEdit" :class="data.status === 0 ? 'grey' : ''">{{ node.label }}</span>
                  <input v-else :ref="data.id" placeholder="请输入内容" v-model="currentValue"
                    @blur="($event) => handleInputBlur($event, data)" />
                  <template v-if="hoveredNodeId === data.id">
                    <i :class="data.status === 0 ? 'el-icon-turn-off delete-btn red' : 'el-icon-open delete-btn green'"
                      @click="toggleCategoryStatus(data)"></i>
                  </template>
                </span>
              </el-tree>
            </div>
          </template>
          <span slot="footer" class="dialog-footer">
            <el-button @click="manageProductsCategoriesVisible = false">关 闭</el-button>
          </span>
        </el-dialog>
        <el-dialog :title="categoryPackageTitle" :visible.sync="categoryPackageVisible" width="40%">
          <el-form :inline="true" :model="categoryPackageForm" class="demo-form-inline"
            v-loading="categoryPackageLoading">
            <el-row>
              <el-form-item label="样式">
                <el-select v-model="categoryPackageForm.package_id" clearable filterable
                  @change="categoryPackageSelected">
                  <el-option v-for="item in packagesList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <br><br>
            <el-row>
              <el-form-item label="效果图预览">
                <el-image
                  style="width: 120px; height: 120px; position: relative; border: solid 1px #DCDFE6; box-sizing: border-box;"
                  :src="categoryPackageForm.src" fit="fill" v-loading="categoryPackagePreviewLoading">
                  <template #error>
                    <div class="image-error">暂无</div>
                  </template>
                </el-image>
              </el-form-item>
            </el-row>
            <br>
            <el-row>
              <el-form-item label="">
                <i class="el-icon-warning-outline"></i>
                <i>设置包装和上传产品, 没有先后顺序要求</i>
              </el-form-item>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveCategoryPackage">保 存</el-button>
            <el-button @click="categoryPackageVisible = false">关 闭</el-button>
          </span>
        </el-dialog>
        <el-dialog title="产品图片重制" :visible.sync="redoProductPackagesVisible" width="40%"
          v-loading="redoProductPackagesLoading" element-loading-text="正在保存, 请稍候">
          <el-form :inline="true" :model="redoProductPackagesForm" class="demo-form-inline">
            <template>
              <el-checkbox :indeterminate="redoProductPackagesForm.isIndeterminate"
                v-model="redoProductPackagesForm.checkAll" @change="redoProductPackagesFormCheckAll">全选</el-checkbox>
              <div style="margin: 15px 0;"></div>
              <el-checkbox-group v-model="redoProductPackagesForm.checkedTypes" @change="redoProductPackagesFormChange">
                <el-checkbox v-for="package_type in redoProductPackagesForm.packageTypes" :label="package_type"
                  :key="package_type">
                  {{ package_type }}
                </el-checkbox>
              </el-checkbox-group>
            </template>
            <br>
            <el-row>
              <el-form-item label="">
                <i class="el-icon-warning-outline"></i>
                选中的选项，产品对应图会陆续自动更新，请注意<b class="red">刷新预热</b>。
              </el-form-item>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="redoProductPackagesVisible = false">取 消</el-button>
            <el-button @click="saveRedoProductPackages">确 定</el-button>
          </span>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="新闻列表" name="news">
        <el-row>
          <el-input v-model="newsKeywords" placeholder="请输入关键字" clearable style="width: 300px; margin-right: 10px;"
            @clear="queryNewsList(true)"></el-input>
          <el-button @click="queryNewsList(true)" icon="el-icon-search" circle title="查询"></el-button>
          <el-button @click="addNews()" icon="el-icon-plus" circle title="新增"></el-button>
        </el-row>
        <br>
        <el-table :data="newsList" border style="width: 100%" height="565" v-loading="newsLoading">
          <el-table-column prop="title" label="标题"></el-table-column>
          <el-table-column prop="meta" label="metas" width="450">
            <template #header>
              <span>metas</span>
              <el-tooltip content="标蓝的表示已经人工编写" placement="right" effect="light">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template v-slot="scope">
              <el-tooltip :content="scope.row.title_suffix" placement="top" effect="light"
                v-if="scope.row.title_suffix">
                <el-tag>title</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>title</el-tag>
              <el-tooltip :content="scope.row.keywords" placement="top" effect="light" v-if="scope.row.keywords">
                <el-tag>keywords</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>keywords</el-tag>
              <el-tooltip :content="scope.row.description" placement="top" effect="light" v-if="scope.row.description">
                <el-tag>description</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>description</el-tag>
              <el-tooltip :content="scope.row.og_title" placement="top" effect="light" v-if="scope.row.og_title">
                <el-tag>og_title</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>og_title</el-tag>
              <el-tooltip :content="scope.row.og_description" placement="top" effect="light"
                v-if="scope.row.og_description">
                <el-tag>og_description</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>og_description</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="发布时间" width="260"></el-table-column>
          <el-table-column prop="status" label="状态" width="90">
            <template v-slot="scope">
              <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ccc"
                @change="toggleNewsStatus(scope.row, scope.$index)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="faq" label="文本" width="80">
            <template v-slot="scope">
              <i :class="scope.row.content ? 'el-icon-check' : 'el-icon-close'"></i>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template v-slot="scope">
              <el-link type="primary" :underline="false" @click="getNewsDetail(scope.row)"
                class="text-small">编辑</el-link>
              <el-link type="danger" :underline="false" @click="deleteNews(scope.row)" class="text-small">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="newsTotal"
            @size-change="changeNewsSize" @current-change="currentNewsChange" :page-sizes="[10, 20, 50, 100]"
            :page-size="newsSize">
          </el-pagination>
        </div>
        <el-dialog :title="newsDetailTitle" :visible.sync="newsDetailVisible" width="40%">
          <el-form :model="newsDetailForm" label-width="110px" :rules="newsDetailRules" ref="newsDetailForm"
            v-loading="newsDetailLoading" element-loading-text="正在保存, 请稍候">
            <el-form-item label="标题" prop="title">
              <el-col :span="22">
                <el-input placeholder="新闻标题" v-model="newsDetailForm.title"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="URL" prop="url">
              <el-col :span="22">
                <el-input placeholder="实际链接, 若为空, 则由系统自动生成(不含.html)" v-model="newsDetailForm.url"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="title">
              <el-input v-model="newsDetailForm.title_suffix"></el-input>
            </el-form-item>
            <el-form-item label="keywords">
              <el-input v-model="newsDetailForm.keywords"></el-input>
            </el-form-item>
            <el-form-item label="description">
              <el-input v-model="newsDetailForm.description"></el-input>
            </el-form-item>
            <el-form-item label="og_title">
              <el-input v-model="newsDetailForm.og_title"></el-input>
            </el-form-item>
            <el-form-item label="og_description">
              <el-input v-model="newsDetailForm.og_description"></el-input>
            </el-form-item>
            <el-form-item label="正文" prop="content">
              <el-col :span="24">
                <div class="editor-box">
                  <quill-editor v-model="newsDetailForm.content" ref="newsDetailContentEditor"
                    :optinotallow="editorOption">
                  </quill-editor>
                </div>
              </el-col>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="newsDetailVisible = false">关 闭</el-button>
            <el-button @click="saveNewsDetail">保 存</el-button>
          </span>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="隐藏列表" name="supplements">
        <el-row>
          <el-col :span="24">
            <div style="display: flex; align-items: center;">
              <el-input v-model="supplementsKeywords" placeholder="请输入关键字" clearable
                style="width: 300px; margin-right: 10px;" @clear="querySupplementsList(true)"></el-input>
              <el-button @click="querySupplementsList(true)" icon="el-icon-search" circle title="查询"></el-button>
              <el-button @click="addSupplements()" icon="el-icon-plus" circle title="新增"></el-button>
              <el-button @click="uploadSupplements()" icon="el-icon-upload2" circle title="批量上传"></el-button>
              <el-button @click="supplementsSettings()" icon="el-icon-s-tools" circle title="设置"></el-button>
              <div class="supplements-progress-box">
                <el-progress type="circle" :percentage="supplementsProgress.percentage" :width="40" :stroke-width="1"
                  style="margin:0 10px;" class="supplements-progress">
                </el-progress>
                <div class="supplements-progress-box-text">
                  <span class="blue">发布: {{ supplementsProgress.done }}</span>
                  <span class="grey">未发布: {{ supplementsProgress.undo }}</span>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <br>
        <el-table :data="supplementsList" border style="width: 100%" height="565" v-loading="supplementsLoading">
          <el-table-column prop="title" label="标题"></el-table-column>
          <el-table-column prop="keywords" label="关键字"></el-table-column>
          <el-table-column prop="meta" label="metas" width="450">
            <template #header>
              <span>metas</span>
              <el-tooltip content="标蓝的表示已经人工编写" placement="right" effect="light">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template v-slot="scope">
              <el-tooltip :content="scope.row.title_suffix" placement="top" effect="light"
                v-if="scope.row.title_suffix">
                <el-tag>title</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>title</el-tag>
              <el-tooltip :content="scope.row.keywords" placement="top" effect="light" v-if="scope.row.keywords">
                <el-tag>keywords</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>keywords</el-tag>
              <el-tooltip :content="scope.row.description" placement="top" effect="light" v-if="scope.row.description">
                <el-tag>description</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>description</el-tag>
              <el-tooltip :content="scope.row.og_title" placement="top" effect="light" v-if="scope.row.og_title">
                <el-tag>og_title</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>og_title</el-tag>
              <el-tooltip :content="scope.row.og_description" placement="top" effect="light"
                v-if="scope.row.og_description">
                <el-tag>og_description</el-tag>
              </el-tooltip>
              <el-tag type="info" v-else>og_description</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="发布时间" width="260"></el-table-column>
          <el-table-column prop="weight_value" label="发布权重" width="100">
            <template v-slot="scope">
              <el-input v-model="scope.row.weight_value" type="number" :max="100" :min="0"
                @blur="blurSaveSupplementsWeightValue(scope.row, 'weight_value')"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="90">
            <template v-slot="scope">
              <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ccc"
                @change="toggleSupplementsStatus(scope.row, scope.$index)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="faq" label="文本" width="80">
            <template v-slot="scope">
              <i :class="scope.row.content ? 'el-icon-check' : 'el-icon-close'"></i>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template v-slot="scope">
              <el-link type="primary" :underline="false" @click="getSupplementsDetail(scope.row)"
                class="text-small">编辑</el-link>
              <el-link type="danger" :underline="false" @click="deleteSupplement(scope.row)"
                class="text-small">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="supplementsTotal"
            @size-change="changeSupplementsSize" @current-change="currentSupplementsChange"
            :page-sizes="[10, 20, 50, 100]" :page-size="supplementsSize">
          </el-pagination>
        </div>
        <el-dialog :title="supplementsDetailTitle" :visible.sync="supplementsDetailVisible" width="40%">
          <el-form :model="supplementsDetailForm" label-width="110px" :rules="supplementsDetailRules"
            ref="supplementsDetailForm" v-loading="supplementsDetailLoading" element-loading-text="正在保存, 请稍候">
            <el-form-item label="标题" prop="title">
              <el-col :span="22">
                <el-input placeholder="新闻标题" v-model="supplementsDetailForm.title"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="URL" prop="url">
              <el-col :span="22">
                <el-input placeholder="实际链接, 若为空, 则由系统自动生成(不含.html)" v-model="supplementsDetailForm.url"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="title">
              <el-input v-model="supplementsDetailForm.title_suffix"></el-input>
            </el-form-item>
            <el-form-item label="weight_value">
              <el-input v-model="supplementsDetailForm.weight_value"></el-input>
            </el-form-item>
            <el-form-item label="keywords">
              <el-input v-model="supplementsDetailForm.keywords"></el-input>
            </el-form-item>
            <el-form-item label="description">
              <el-input v-model="supplementsDetailForm.description"></el-input>
            </el-form-item>
            <el-form-item label="og_title">
              <el-input v-model="supplementsDetailForm.og_title"></el-input>
            </el-form-item>
            <el-form-item label="og_description">
              <el-input v-model="supplementsDetailForm.og_description"></el-input>
            </el-form-item>
            <el-form-item label="正文" prop="content">
              <el-col :span="24">
                <div class="editor-box">
                  <quill-editor v-model="supplementsDetailForm.content" ref="supplementsDetailContentEditor"
                    :optinotallow="editorOption">
                  </quill-editor>
                </div>
              </el-col>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="supplementsDetailVisible = false">关 闭</el-button>
            <el-button @click="saveSupplementsDetail">保 存</el-button>
          </span>
        </el-dialog>
        <el-dialog title="批量上传" :visible.sync="uploadSupplementsVisible" style="margin-top: -80px;">
          <el-form v-loading="uploadSupplementsLoading" label-width="100px">
            <el-descriptions>
              <el-descriptions-item label="当前操作站点"><b class="red">{{ domain }}</b></el-descriptions-item>
            </el-descriptions>
            <el-row>
              <el-col :span="24">
                <el-form-item label="选择文件">
                  <el-upload class="upload-demo" ref="uploadSupplements"
                    :action="this.$axios.defaults.baseURL + `websites/backend/supplements/upload?domain=${domain}`"
                    :headers="headersObj" :file-list="uploadSupplementsFileList" :auto-upload="false" :limit="1"
                    :on-success="uploadSupplementsSuccess">
                    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="">
                  <i class="el-icon-warning"></i>
                  <i>本模块所有内容默认不发布</i>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="uploadSupplementsVisible = false; uploadSupplementsFileList = []">取 消</el-button>
            <el-button type="primary" @click="submitUploadSupplements">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="计划任务" :visible.sync="supplementsSettingsVisible" :close-on-click-modal="false">
          <el-form :model="supplementsSettingsForm" label-width="120px" :rules="supplementsSettingsRules"
            ref="supplementsSettingsForm" v-loading="supplementsSettingsLoading"
            :element-loading-text="supplementsSettingsLoadingText">
            <!-- <el-form-item label="整体开关" prop="">
              <el-switch active-text="全部激活" inactive-text="全部关闭" v-model="supplementsActive"></el-switch>
            </el-form-item> -->
            <!-- <h4>计划任务</h4>
            <br> -->
            <el-form-item label="每日定量" prop="quantity">
              <el-col :span="12">
                <el-input v-model="supplementsSettingsForm.quantity" type="number" min="0" max="99"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="发布时机" prop="timing">
              <el-col :span="12">
                <el-select v-model="supplementsSettingsForm.timing">
                  <el-option v-for="item in timingOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="el-icon-info blue"> (北京时间)</i>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="supplementsSettingsVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveSupplementsSettings()">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="站点设置" name="seo">
        <div class="seo-card-box">
          <el-card class="seo-card" v-loading="seoLoading">
            <div slot="header" class="clearfix">
              <span>文案</span>
            </div>
            <el-table :data="seoList" height="310px" :row-class-name="seoRowClassName">
              <el-table-column prop="id" label="编号" width="50px">
              </el-table-column>
              <el-table-column prop="title" label="文案">
                <template v-slot="scope">
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content" v-html="scope.row.html"></div>
                    <span v-if="scope.row.title != null && scope.row.title.length > 40">
                      {{ scope.row.title.substring(0, 40) + '...' }}
                    </span>
                    <span v-else>{{ scope.row.title }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="" label="操作" width="50">
                <template v-slot="scope">
                  <i class="el-icon-success green" v-if="scope.row.used === true"></i>
                  <el-link type="primary" @click="useSeo(scope.row)" v-if="scope.row.used === false"
                    :underline="false">使用</el-link>
                </template>
              </el-table-column>
            </el-table>
          </el-card>

          <el-card class="seo-card" v-loading="seoLoading">
            <div slot="header" class="clearfix">
              <span>站长工具</span>
              <el-button style="float: right; padding: 3px 0" type="text" @click="saveWebsiteSeo">保存</el-button>
            </div>
            <el-form label-position="left" label-width="140px" :model="seoForm">
              <el-form-item label="Google站点验证码">
                <el-input v-model="seoForm.google_site_verification"></el-input>
              </el-form-item>
              <el-form-item label="Google GA id">
                <el-input v-model="seoForm.google_analysis_id"></el-input>
              </el-form-item>
              <el-form-item label="Bing验证码">
                <el-input v-model="seoForm.bing_site_auth"></el-input>
              </el-form-item>
              <el-form-item label="yandex验证码">
                <el-input v-model="seoForm.yandex_site_auth"></el-input>
              </el-form-item>
              <el-form-item label="百度验证码">
                <el-input v-model="seoForm.baidu_site_auth"></el-input>
              </el-form-item>
            </el-form>
          </el-card>

          <el-card class="seo-card" v-loading="seoLoading">
            <div slot="header" class="clearfix">
              <span>站点地图</span>
            </div>
            <template>
              <el-descriptions
                v-if="seoForm.sitemap != null && seoForm.sitemap != '' && seoForm.sitemap != 'undefined'">
                <el-descriptions-item label="大小">{{ seoForm.sitemap.size }}</el-descriptions-item>
                <el-descriptions-item label="修改时间">{{ seoForm.sitemap.time }}</el-descriptions-item>
              </el-descriptions>
              <span v-else class="red text-base"><i class="el-icon-error"></i> 未检测到文件<br><br></span>
            </template>
            <div class="sitemap-card-upload-box">
              <el-upload class="upload-demo" drag ref="uploadSitemapRef"
                :action="this.$axios.defaults.baseURL + `websites/backend/seo/sitemap_upload?domain=${domain}&lang=${lang}`"
                :headers="headersObj" :on-success="uploadSitemapSuccess" :on-error="uploadSitemapError" accept=".xml">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </el-upload>
            </div>
            <span class="grey text-base"><i class="el-icon-warning"></i> 上传会覆盖原来的文件 此操作不可撤销</span>
          </el-card>

          <el-card class="seo-card" v-loading="seoLoading">
            <div slot="header" class="clearfix">
              <span>备案信息</span>
              <el-button style="float: right; padding: 3px 0" type="text" @click="saveWebsiteSeo">保存</el-button>
            </div>
            <el-form label-position="left" label-width="140px" :model="seoForm">
              <el-form-item label="工信部备案号(ICP)">
                <el-input v-model="seoForm.icp_record_no"></el-input>
              </el-form-item>
              <el-form-item label="公安部备案号">
                <el-input v-model="seoForm.police_record_no"></el-input>
              </el-form-item>
            </el-form>
          </el-card>
        </div>
      </el-tab-pane>
      <el-tab-pane label="合作伙伴" name="partners">
        <div class="others-card-box">
          <el-card class="others-card" v-loading="partnersLoading">
            <div slot="header" class="clearfix">
              <span>合作伙伴</span>
              <el-button style="float: right; padding: 3px 5px" type="text" @click="clearAllPartners"
                class="red">清空</el-button>
              <el-button style="float: right; padding: 3px 5px" type="text"
                @click="uploadPartnersList = []; uploadPartnersVisible = true">更新</el-button>
            </div>
            <div class=" website-media-image-box" v-loading="partnersLoading">
              <div class="media-image-box" v-for="(item, index) in partnersList" :key="index">
                <el-image :src="item.url + '?' + new Date().getTime()" :preview-src-list="[item.url]" fit="contain" lazy
                  :title="item.name"></el-image>
                <span class="text-small media-image-title">{{ item.name }}</span>
              </div>
            </div>
          </el-card>
        </div>
        <el-dialog title="更新合作伙伴" :visible.sync="uploadPartnersVisible">
          <el-upload class="upload-demo" ref="uploadPartners"
            :action="this.$axios.defaults.baseURL + `websites/backend/partners/upload?domain=${domain}`"
            :file-list="uploadPartnersList" :auto-upload="false" :multiple="true">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success"
              @click="submitPartnersUpload">确定上传</el-button>
            <div slot="tip" class="el-upload__tip">选取文件后, 点击确定上传</div>
          </el-upload>
          <div slot="footer" class="dialog-footer">
            <el-button @click="uploadPartnersVisible = false; uploadPartnersList = []; getPartners()">完 成</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="国际化" name="internationalization">
        <el-row>
          <el-button @click="addMultilingualLanguages()" icon="el-icon-plus" circle title="新增多语种"></el-button>
          <i class="text-extra-small">此处只展示英文站以外的网站</i>
        </el-row>
        <br>
        <el-table :data="multilingualLanguagesList" border style="width: 100%" height="565"
          v-loading="multilingualLanguagesLoading">
          <el-table-column prop="lang_show" label="语种" width="150">
          </el-table-column>
          <el-table-column prop="lang" label="代码" width="60">
          </el-table-column>
          <el-table-column prop="url" label="源站地址">
            <template #header>
              <span>源站地址</span>
              <el-tooltip content="多语种的源站地址均不相同" placement="right" effect="light">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template v-slot="scope">
              {{ scope.row.url }}
              <span class="action-icon" @click="copy(scope.row.url)"><i class="el-icon-copy-document"></i></span>
              <span class="action-icon" @click="view(scope.row.url)"><i class="el-icon-view"></i></span>
            </template>
          </el-table-column>
          <el-table-column prop="processes" label="翻译进度" width="200">
            <template #header>
              <span>翻译进度</span>
              <el-tooltip content="绿色表示已完成" placement="right" effect="light">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template v-slot="scope">
              <div style="
                display: grid;
                grid-template-columns: repeat(7, 1fr);
                grid-template-rows: auto auto;
                text-align: center;
                gap: 4px;
              ">
                <el-tooltip content="栏目" placement="top">
                  <i class="el-icon-menu" :class="scope.row.p1 ? 'status-green' : 'status-red'"></i>
                </el-tooltip>
                <el-tooltip content="产品分类" placement="top">
                  <i class="el-icon-set-up" :class="scope.row.p2 ? 'status-green' : 'status-red'"></i>
                </el-tooltip>
                <el-tooltip content="产品主表" placement="top">
                  <i class="el-icon-shopping-bag-2" :class="scope.row.p3 ? 'status-green' : 'status-red'"></i>
                </el-tooltip>
                <el-tooltip content="基础属性" placement="top">
                  <i class="el-icon-notebook-2" :class="scope.row.p4 ? 'status-green' : 'status-red'"></i>
                </el-tooltip>
                <el-tooltip content="补充属性" placement="top">
                  <i class="el-icon-news" :class="scope.row.p5 ? 'status-green' : 'status-red'"></i>
                </el-tooltip>
                <el-tooltip content="包装运输" placement="top">
                  <i class="el-icon-position" :class="scope.row.p6 ? 'status-green' : 'status-red'"></i>
                </el-tooltip>
                <el-tooltip content="FAQ" placement="top">
                  <i class="el-icon-chat-dot-round" :class="scope.row.p7 ? 'status-green' : 'status-red'"></i>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="90">
            <template v-slot="scope">
              <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ccc"
                @change="toggleMultilingualLanguagesStatus(scope.row, scope.$index)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间" width="200">
          </el-table-column>
          <el-table-column prop="created_by" label="创建人" width="100">
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template v-slot="scope">
              <el-link type="primary" :underline="false" @click="view(scope.row.url)" class="text-small">预览</el-link>
              <el-link type="danger" :underline="false" @click="deleteMultilingualLanguages(scope.row)"
                class="text-small">删除</el-link>
              <el-link type="primary" :underline="false" @click="manageMultilingualLanguages(scope.row)"
                class="text-small">进入管理</el-link>
              <el-link type="primary" :underline="false" @click="redoMultilingualLanguages(scope.row)"
                class="text-small">更新</el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog title="新增多语种" :visible.sync="addMultilingualLanguagesVisible" width="60%" style="margin-top: -60px;">
          <el-form :model="addMultilingualLanguagesForm" label-width="110px" ref="addMultilingualLanguagesForm"
            v-loading="addMultilingualLanguagesLoading" :element-loading-text="addMultilingualLanguagesLoadingText">
            <el-row>
              <el-col :span="4" v-for="item in addMultilingualLanguagesFormCheckers" :key="item.code">
                <el-checkbox :label="item.code" v-model="addMultilingualLanguagesForm.checkedValues"
                  :disabled="item.checked">
                  {{ item.lang_cn }}
                </el-checkbox>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="addMultilingualLanguagesVisible = false">关 闭</el-button>
            <el-button @click="saveAddMultilingualLanguages">保 存</el-button>
          </span>
        </el-dialog>
        <el-dialog :title="redoMultilingualLanguagesTitle" :visible.sync="redoMultilingualLanguagesVisible" width="40%">
          <el-form :inline="true" :model="redoMultilingualLanguagesForm" class="demo-form-inline"
            v-loading="redoMultilingualLanguagesLoading">
            <el-row>
              <el-form-item label="类型">
                <el-radio-group v-model="redoMultilingualLanguagesForm.type">
                  <el-radio-button label="栏目"></el-radio-button>
                  <el-radio-button label="产品"></el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="动作">
                <el-radio-group v-model="redoMultilingualLanguagesForm.action">
                  <el-radio-button label="补充"></el-radio-button>
                  <el-radio-button label="重做"></el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveRedoMultilingualLanguages">保 存</el-button>
            <el-button @click="redoMultilingualLanguagesVisible = false">关 闭</el-button>
          </span>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="共性词" name="knowledge">
        <el-row>
          <el-col :span="24">
            <div style="display: flex; align-items: center;">
              <el-select v-model="knowledgeType" placeholder="请选择" @change="queryKnowledgeList(true)">
                <el-option label="产品" value="products"></el-option>
                <el-option label="产品2" value="products2"></el-option>
                <el-option label="品牌" value="brands"></el-option>
                <el-option label="Custom" value="custom"></el-option>
                <el-option label="试剂" value="regeant"></el-option>
                <el-option label="药辅" value="pharmaceutical"></el-option>
                <el-option label="添加剂-产品" value="additives-products"></el-option>
                <el-option label="添加剂-共性词" value="additives"></el-option>
                <!-- <el-option label="食品添加剂" value="foods-additive"></el-option> -->
                <!-- <el-option label="饲料添加剂" value="feeds-additive"></el-option> -->
                <el-option label="special" value="special"></el-option>
                <el-option label="联想词-型号" value="supplements"></el-option>
                <el-option label="联想词-商业词汇" value="supplements2"></el-option>
                <el-option label="联想词-auto" value="supplements3"></el-option>
                <el-option label="专题(直取)" value="features"></el-option>
                <el-option label="专题(控AI)" value="features2"></el-option>
              </el-select>
              &nbsp;&nbsp;
              <el-input v-model="knowledgeKeywords" placeholder="请输入关键字" clearable
                style="width: 300px; margin-right: 10px;" @clear="queryKnowledgeList(true)"></el-input>
              <el-button @click="queryKnowledgeList(true)" icon="el-icon-search" circle title="查询"></el-button>
              <el-button @click="addKnowledge()" icon="el-icon-plus" circle v-if="knowledgeType !== 'supplements'"
                :disabled="website.authority_score === undefined || website.authority_score === '' || website.authority_score === null"
                :title="website.authority_score === undefined || website.authority_score === '' || website.authority_score === null ? '请先设置权重值' : '新增'">
              </el-button>
              <el-button @click="uploadKnowledge()" icon="el-icon-upload2" circle
                :disabled="website.authority_score === undefined || website.authority_score === '' || website.authority_score === null"
                :title="website.authority_score === undefined || website.authority_score === '' || website.authority_score === null ? '请先设置权重值' : '批量上传'">
              </el-button>
            </div>
          </el-col>
        </el-row>
        <br>
        <el-table :data="knowledgeList" border style="width: 100%" height="565" v-loading="knowledgeLoading">
          <el-table-column prop="word" label="词" width="500"></el-table-column>
          <el-table-column prop="batch" label="所属文件" v-if="knowledgeType === 'supplements'"></el-table-column>
          <el-table-column prop="is_regean" label="试剂" v-if="knowledgeType === 'products'">
            <template v-slot="scope">
              <i :class="scope.row.is_regean ? 'el-icon-check green' : 'el-icon-close red'"></i>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="文本">
            <template v-slot="scope">
              <i :class="scope.row.content ? 'el-icon-check green' : 'el-icon-close red'"></i>
            </template>
          </el-table-column>
          <el-table-column label="删除">
            <template v-slot="scope">
              <!-- <el-link type="primary" :underline="false" @click="getKnowledgeDetail(scope.row)" class="text-small"
                v-if="knowledgeType === 'products' || knowledgeType === 'brands'">编辑</el-link> -->
              <el-link type="danger" :underline="false" @click="deleteKnowledge(scope.row)" class="text-small"
                v-if="knowledgeType !== 'supplements'">删除</el-link>

              <!-- <el-link type="primary" :underline="false" @click="getKnowledgeDetail(scope.row)" class="text-small"
                v-if="knowledgeType === 'supplements'">按批次编辑</el-link> -->
              <el-link type="danger" :underline="false" @click="deleteKnowledge(scope.row)" class="text-small"
                v-if="knowledgeType === 'supplements'">按批次删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="knowledgeTotal"
            @size-change="changeKnowledgeSize" @current-change="currentKnowledgeChange" :page-sizes="[10, 20, 50, 100]"
            :page-size="knowledgeSize">
          </el-pagination>
        </div>
        <el-dialog :title="knowledgeDetailTitle" :visible.sync="knowledgeDetailVisible" width="40%">
          <el-form :model="knowledgeDetailForm" label-width="110px" :rules="knowledgeDetailRules"
            ref="knowledgeDetailForm" v-loading="knowledgeDetailLoading" element-loading-text="正在保存, 请稍候">
            <el-row>
              <el-col :span="16">
                <el-form-item label="词条" prop="word">
                  <el-input placeholder="输入词条" v-model="knowledgeDetailForm.word"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="knowledgeType === 'products'">
                <el-form-item label="" prop="is_regean">
                  <el-checkbox v-model="knowledgeDetailForm.is_regean">试剂</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="正文" prop="content" v-if="false">
              <el-col :span="24">
                <div class="editor-box">
                  <quill-editor v-model="knowledgeDetailForm.content" ref="knowledgeDetailContentEditor"
                    :optinotallow="editorOption">
                  </quill-editor>
                </div>
              </el-col>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="knowledgeDetailVisible = false">关 闭</el-button>
            <el-button @click="saveKnowledgeDetail">保 存</el-button>
          </span>
        </el-dialog>
        <el-dialog title="批量上传" :visible.sync="uploadKnowledgeVisible" style="margin-top: -80px;">
          <el-form v-loading="uploadKnowledgeLoading" label-width="100px">
            <el-descriptions>
              <el-descriptions-item label="当前操作类型"><b class="red">{{ knowledgeType }}</b></el-descriptions-item>
            </el-descriptions>
            <el-row>
              <el-col :span="24">
                <el-form-item label="选择文件">
                  <el-upload class="upload-demo" ref="uploadKnowledge"
                    :action="this.$axios.defaults.baseURL + `websites/backend/knowledges/upload?domain=${domain}&type=${knowledgeType}`"
                    :headers="headersObj" :file-list="uploadKnowledgeFileList" :auto-upload="false" multiple
                    :on-success="uploadKnowledgeSuccess">
                    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="uploadKnowledgeVisible = false; uploadKnowledgeFileList = []">取 消</el-button>
            <el-button type="primary" @click="submitUploadKnowledge">确 定</el-button>
          </span>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="运维" name="deploy" v-loading="loading">
        <el-descriptions :title="'主域名 ' + domain + ' 状态检查'" :column="2" :labelStyle="{ 'width': '120px' }" border>
          <template slot="extra">
            <el-button type="primary" size="small" @click="queryDeploy">刷新</el-button>
          </template>
          <el-descriptions-item label="有效期">
            <span :class="deployInfo.expire_warning === true ? 'red' : ''">{{ deployInfo.expire_date }}</span>
            <i class="el-icon-check green" v-if="deployInfo.expired === false"></i>
            <i class="el-icon-close red" v-if="deployInfo.expired === true"><b class="red">已过期</b></i>
            <i class="el-icon-warning red" v-if="deployInfo.expire_warning === true"><b class="red">即将过期</b></i>
          </el-descriptions-item>
          <el-descriptions-item label="腾讯云余额">
            <span :class="deployInfo.tencent_balance < 100 ? 'red' : ''" v-if="deployInfo.tencent_balance > 0">
              ¥ {{ deployInfo.tencent_balance }}<i class="el-icon-check green"></i>
            </span>
            <span class="red" v-else>¥ {{ deployInfo.tencent_balance }}<i class="el-icon-close red"></i></span>
          </el-descriptions-item>
          <el-descriptions-item label="DNS托管">
            <div v-if="deployInfo.in_dnspod === true">
              <div v-if="deployInfo.dns_status === 'DNSERROR'">
                <span>已托管但不正常</span>
              </div>
              <div v-else>
                <span v-if="deployInfo.dnspod_status === 'ENABLE'">已正常托管 <i class="el-icon-check green"></i></span>
                <span v-else>已正常托管但已关闭</span>
              </div>
            </div>
            <div v-else>
              <span>未托管至DNS</span>
              <el-link type="primary" :underline="false" @click="addToDnspod">去托管</el-link>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="阿里云余额">
            <span :class="deployInfo.aliyun_balance < 100 ? 'red' : ''" v-if="deployInfo.aliyun_balance > 0">
              ¥ {{ deployInfo.aliyun_balance }}<i class="el-icon-check green"></i>
            </span>
            <span class="red" v-else>¥ {{ deployInfo.aliyun_balance }}<i class="el-icon-close red"></i></span>
          </el-descriptions-item>
        </el-descriptions>
        <el-divider></el-divider>
        <el-descriptions title="部署清单" :column="1" border>
          <template slot="extra">
            <el-button type="primary" size="small" @click="submitDeploy">提交部署</el-button>
          </template>
        </el-descriptions>
        <el-table ref="multipleTable" :data="deployList" @selection-change="onSelectionChange" height="440" stripe
          row-key="id" class="hover-icon-table">
          <el-table-column type="selection" width="55" fixed="left" :selectable="rowSelectable" />
          <el-table-column prop="subdomain" label="二级域名" width="100" />
          <el-table-column prop="source_address" label="源站地址">
            <template v-slot="scope">
              <span>
                {{ scope.row.source_address }}
                <el-link :underline="false"><i class="el-icon-copy-document hover-icon"
                    @click="copy(scope.row.source_address)"></i></el-link>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="180">
            <template v-slot="scope">
              <span :class="scope.row.status === '已提交'
                ? 'orange'
                : scope.row.status === '已完成'
                  ? 'green'
                  : scope.row.status === '部署失败'
                    ? 'red'
                    : ''">
                {{
                  scope.row.status === '已提交' && scope.row.process !== null
                    ? scope.row.process
                    : scope.row.status
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="选项" width="500" fixed="right">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.ssl" @change="onRowOptionChanged(scope.row)"
                :disabled="scope.row.status === '已提交' || scope.row.status === '已完成'">
                SSL
              </el-checkbox>
              <el-select v-model="scope.row.area" size="mini" placeholder="加速区" style="width: 160px; margin-left: 8px;"
                @change="onRowOptionChanged(scope.row)"
                :disabled="scope.row.status === '已提交' || scope.row.status === '已完成'">
                <el-option v-for="item in deployOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
              <el-button type="primary" size="small" @click="refreshCDNV2(scope.row)"
                style="margin-left: 10px;">刷新CDN</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="内链" name="internal_link" v-loading="loading">
        <el-row>
          <el-col :span="24">
            <div style="display: flex; align-items: center;">
              <el-input v-model="internalLinkKeywords" placeholder="请输入关键字" clearable
                style="width: 300px; margin-right: 10px;" @clear="queryInternalLinkList(true)"></el-input>
              <el-button @click="queryInternalLinkList(true)" icon="el-icon-search" circle title="查询"></el-button>
              <el-button @click="addInternalLink()" icon="el-icon-plus" circle></el-button>
              <el-button @click="uploadInternalLink()" icon="el-icon-upload2" circle></el-button>
            </div>
          </el-col>
        </el-row>
        <br>
        <el-table :data="internalLinkList" border style="width: 100%" height="565" v-loading="internalLinkLoading">
          <el-table-column prop="keyword" label="词"></el-table-column>
          <el-table-column prop="enabled" label="激活" width="100">
            <template v-slot="scope">
              <el-switch v-model="scope.row.enabled" active-color="#13ce66" inactive-color="#ccc"
                @change="toggleInternalLinkEnabled(scope.row, scope.$index)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="locked" label="锁定" width="100">
            <template v-slot="scope">
              <el-switch v-model="scope.row.locked" active-color="#13ce66" inactive-color="#ccc"
                @change="toggleInternalLinkLocked(scope.row, scope.$index)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="scanned" label="已扫描" width="100">
            <template v-slot="scope">
              <i :class="scope.row.scanned ? 'el-icon-check green' : 'el-icon-close red'"></i>
            </template>
          </el-table-column>
          <el-table-column prop="hit_counts" label="命中次数" width="100">
            <template v-slot="scope">
              <span :class="scope.row.hit_counts < 1 && scope.row.scanned ? 'red' : ''">
                {{ scope.row.scanned ? scope.row.hit_counts : '?' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="删除" width="100">
            <template v-slot="scope">
              <el-link type="danger" :underline="false" @click="deleteInternalLink(scope.row)"
                class="text-small">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="internalLinkTotal"
            @size-change="changeInternalLinkSize" @current-change="currentInternalLinkChange"
            :page-sizes="[10, 20, 50, 100]" :page-size="internalLinkSize">
          </el-pagination>
        </div>
        <el-dialog title="添加内链关键词" :visible.sync="internalLinkDetailVisible" width="40%">
          <el-form :model="internalLinkDetailForm" label-width="110px" :rules="internalLinkDetailRules"
            ref="internalLinkDetailForm" v-loading="internalLinkDetailLoading" element-loading-text="正在保存, 请稍候">
            <el-row>
              <el-col :span="16">
                <el-form-item label="关键词" prop="keyword">
                  <el-input placeholder="输入关键词" v-model="internalLinkDetailForm.keyword"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="internalLinkDetailVisible = false">关 闭</el-button>
            <el-button @click="saveInternalLinkDetail">保 存</el-button>
          </span>
        </el-dialog>
        <el-dialog title="批量上传" :visible.sync="uploadInternalLinkVisible" style="margin-top: -80px;">
          <el-form v-loading="uploadInternalLinkLoading" label-width="100px">
            <el-row>
              <el-col :span="24">
                <el-form-item label="选择文件">
                  <el-upload class="upload-demo" ref="uploadInternalLink"
                    :action="this.$axios.defaults.baseURL + `websites/backend/internal_links/upload?domain=${domain}`"
                    :headers="headersObj" :file-list="uploadInternalLinkFileList" :auto-upload="false" multiple
                    :on-success="uploadInternalLinkSuccess">
                    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="uploadInternalLinkVisible = false; uploadInternalLinkFileList = []">取 消</el-button>
            <el-button type="primary" @click="submitUploadInternalLink">确 定</el-button>
          </span>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="主菜单设置" :visible.sync="pageSettingsVisible" width="40%">
      <template>
        <div v-loading="pageSettingsLoading">
          <el-tree :data="pageSettingsData" highlight-current node-key="id" :props="{
            children: 'children',
            label: 'title'
          }" :default-expanded-keys="defaultExpandedKeys" :default-checked-keys="defaultCheckedKeys"
            ref="pageSettingsData" show-checkbox draggable>
          </el-tree>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="savePageSettings()">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog title="底部菜单设置" :visible.sync="footerPageSettingsVisible" width="40%">
      <template>
        <div v-loading="footerPageSettingsLoading">
          <el-tree :data="footerPageSettingsData" highlight-current node-key="id" :props="{
            children: 'children',
            label: 'title'
          }" :default-expanded-keys="footerDefaultExpandedKeys" :default-checked-keys="footerDefaultCheckedKeys"
            ref="footerPageSettingsData" show-checkbox draggable>
          </el-tree>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="saveFooterPageSettings()">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Nav from '../../Global/Nav.vue'
import { quillEditor } from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: 'WebsitesList',
  components: {
    Nav,
    quillEditor
  },
  data() {
    return {
      titleConfig: [
        { Choice: '.ql-insertMetric', title: '跳转配置' },
        { Choice: '.ql-bold', title: '加粗' },
        { Choice: '.ql-italic', title: '斜体' },
        { Choice: '.ql-underline', title: '下划线' },
        { Choice: '.ql-header', title: '段落格式' },
        { Choice: '.ql-strike', title: '删除线' },
        { Choice: '.ql-blockquote', title: '块引用' },
        { Choice: '.ql-code', title: '插入代码' },
        { Choice: '.ql-code-block', title: '插入代码段' },
        { Choice: '.ql-font', title: '字体' },
        { Choice: '.ql-size', title: '字体大小' },
        { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
        { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
        { Choice: '.ql-direction', title: '文本方向' },
        { Choice: '.ql-header[value="1"]', title: 'h1' },
        { Choice: '.ql-header[value="2"]', title: 'h2' },
        { Choice: '.ql-align', title: '对齐方式' },
        { Choice: '.ql-color', title: '字体颜色' },
        { Choice: '.ql-background', title: '背景颜色' },
        { Choice: '.ql-image', title: '图像' },
        { Choice: '.ql-video', title: '视频' },
        { Choice: '.ql-link', title: '添加链接' },
        { Choice: '.ql-formula', title: '插入公式' },
        { Choice: '.ql-clean', title: '清除字体格式' },
        { Choice: '.ql-script[value="sub"]', title: '下标' },
        { Choice: '.ql-script[value="super"]', title: '上标' },
        { Choice: '.ql-indent[value="-1"]', title: '向左缩进' },
        { Choice: '.ql-indent[value="+1"]', title: '向右缩进' },
        { Choice: '.ql-header .ql-picker-label', title: '标题大小' },
        { Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一' },
        { Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二' },
        { Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三' },
        { Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四' },
        { Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五' },
        { Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六' },
        { Choice: '.ql-header .ql-picker-item:last-child', title: '标准' },
        { Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号' },
        { Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号' },
        { Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号' },
        { Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准' },
        { Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐' },
        { Choice: '.ql-align .ql-picker-item[data-value="center"]', title: '居中对齐' },
        { Choice: '.ql-align .ql-picker-item[data-value="right"]', title: '居右对齐' },
        { Choice: '.ql-align .ql-picker-item[data-value="justify"]', title: '两端对齐' }
      ],
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'], // 加粗 斜体 下划线 删除线
            [{ size: [12, 14, 16] }], // 字体大小
            [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
            [{ align: [] }], // 对齐方式
            ['clean'], // 清除文本格式
            ['link', 'image', 'video'] // 链接、图片、视频
            // ['link'] // 链接、图片、视频
          ]
        },
        placeholder: '请输入正文'
      },
      uploadApi: this.$axios.defaults.baseURL + 'websites/backend/upload',
      headersObj: {
        'x-authorization-token': this.$userinfo.api_token
      },
      activeName: 'basic',
      timingOptions: [],
      loading: true,
      domain: '',
      lang: 'en',
      languages: {},
      website: {
        turning_email_pool_info: {
          id: null,
          title: '',
          period: null,
          details: ''
        },
        creator: {},
        saler: {},
        authority_score: ''
      },
      editTurningEmailPoolVisible: false,
      salers: [],
      pageSettingsVisible: false,
      pageSettingsLoading: false,
      pageSettingsData: [],
      pagesList: [],
      pagesLoading: false,
      pagesDetailVisible: false,
      pagesDetailTitle: '',
      pagesDetailLoading: false,
      pagesDetailLoadingText: '',
      pagesDetailForm: {
        keywords: '',
        description: '',
        og_title: '',
        og_description: '',
        content: ''
      },
      defaultExpandedKeys: [],
      defaultCheckedKeys: [],
      footerPageSettingsVisible: false,
      footerPageSettingsLoading: false,
      footerPageSettingsData: [],
      footerDefaultExpandedKeys: [],
      footerDefaultCheckedKeys: [],
      logoSettingsVisible: false,
      logoInfo: {},
      bladesloading: true,
      bladesloadingText: '',
      bladesList: [],
      colorSettingsVisible: false,
      siteColors: {
        first: '',
        second: '',
        third: ''
      },
      mediaType: 'images',
      mediaList: [],
      medialoading: true,
      renamedMediaName: '',
      uploadMediaVisible: false,
      uploadMediaList: [],
      productsKeywords: '',
      productsLoading: false,
      productsList: [],
      productsTotal: 0,
      productsSize: 10,
      productsPage: 1,
      productDetailLoading: false,
      productDetailVisible: false,
      productDetailDiaTitle: '',
      productDetailLoadingText: '',
      productDetail: {
        product: '',
        cas: '',
        category_id: '',
        type: '',
        url: '',
        shape: '',
        specifications: '',
        keywords: '',
        description: '',
        og_title: '',
        og_description: '',
        properties: [],
        packing_storage: {
          packing: '',
          storage: '',
          shipping: ''
        },
        generals: [],
        faqs: []
      },
      productDetailRules: {},
      uploadProductsVisible: false,
      uploadProductsLoading: false,
      uploadProductsFileList: [],
      manageProductsCategoriesVisible: false,
      productCategoriesLoading: true,
      productCategoriesOptions: [],
      productCategoriesData: [],
      hoveredNodeId: null,
      currentValue: '',
      productCategoriesForm: {
        category: '',
        parent_id: ''
      },
      newsKeywords: '',
      newsLoading: false,
      newsList: [],
      newsTotal: 0,
      newsSize: 10,
      newsPage: 1,
      newsDetailTitle: '',
      newsDetailLoading: false,
      newsDetailVisible: false,
      newsDetailForm: {
        title: '',
        url: '',
        content: '',
        keywords: '',
        description: '',
        og_title: '',
        og_description: ''
      },
      newsDetailRules: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'commit' }
        ]
      },
      supplementsActive: false,
      supplementsKeywords: '',
      supplementsLoading: false,
      supplementsProgress: {
        percentage: 0,
        done: 0,
        undo: 0
      },
      supplementsList: [],
      supplementsTotal: 0,
      supplementsSize: 10,
      supplementsPage: 1,
      supplementsDetailTitle: '',
      supplementsDetailLoading: false,
      supplementsDetailVisible: false,
      supplementsDetailForm: {
        title: '',
        url: '',
        content: '',
        keywords: '',
        description: '',
        og_title: '',
        og_description: '',
        weight_value: 0
      },
      supplementsDetailRules: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'commit' }
        ]
      },
      uploadSupplementsVisible: false,
      uploadSupplementsLoading: false,
      uploadSupplementsFileList: [],
      supplementsSettingsVisible: false,
      supplementsSettingsLoading: false,
      supplementsSettingsLoadingText: '',
      supplementsSettingsForm: {
        quantity: 2,
        timing: "02:00"
      },
      supplementsSettingsRules: {
        quantity: [
          { required: true, message: '发布数量不合法', trigger: 'commit' }
        ]
      },
      seoForm: {
        google_site_verification: '',
        google_analysis_id: '',
        bing_site_auth: '',
        yandex_site_auth: '',
        baidu_site_auth: '',
        sitemap: []
      },
      seoList: [],
      seoLoading: false,
      multilingualLanguagesList: [],
      multilingualLanguagesLoading: false,
      addMultilingualLanguagesVisible: false,
      addMultilingualLanguagesForm: {
        checkedValues: []
      },
      addMultilingualLanguagesFormCheckers: [],
      addMultilingualLanguagesLoading: false,
      addMultilingualLanguagesLoadingText: '',
      redoMultilingualLanguagesTitle: '',
      redoMultilingualLanguagesVisible: false,
      redoMultilingualLanguagesLoading: false,
      redoMultilingualLanguagesForm: {
        domain: '',
        type: '',
        action: '补充',
        lang: ''
      },
      partnersList: [],
      partnersLoading: false,
      uploadPartnersVisible: false,
      uploadPartnersList: [],
      knowledgeType: 'products',
      knowledgeKeywords: '',
      knowledgeLoading: false,
      knowledgeList: [],
      knowledgeTotal: 0,
      knowledgeSize: 10,
      knowledgePage: 1,
      knowledgeDetailTitle: '',
      knowledgeDetailVisible: false,
      knowledgeDetailLoading: false,
      knowledgeDetailForm: {
        word: '',
        is_regean: false,
        batch: ''
      },
      knowledgeDetailRules: {
        word: [
          { required: true, message: '本项不能为空', trigger: 'commit' }
        ]
      },
      uploadKnowledgeVisible: false,
      uploadKnowledgeLoading: false,
      uploadKnowledgeFileList: [],
      contentsType: 'product_category',
      contentsTypes: [],
      contentsLoading: false,
      contentsList: [],
      contentsTotal: 0,
      contentsSize: 10,
      contentsDetailTitle: '',
      contentsDetailVisible: false,
      contentsDetailLoading: false,
      contentsDetailForm: {},
      contentsDetailRules: {},
      packagesList: [],
      categoryPackageTitle: '',
      categoryPackageVisible: false,
      categoryPackageLoading: false,
      categoryPackagePreviewLoading: false,
      categoryPackageForm: {
        package_id: '',
        src: '',
        category_id: ''
      },
      redoProductPackagesVisible: false,
      redoProductPackagesLoading: false,
      redoProductPackagesForm: {
        checkAll: false,
        checkedTypes: [],
        packageTypes: ['包装', '小样', '2D', '3D'],
        isIndeterminate: true
      },
      deployInfo: {
        'expire_date': '',
        'dns_status': '',
        'tencent_balance': '',
        'aliyun_balance': ''
      },
      deployList: [],
      deployForm: {
        items: []
      },
      selectedIdSet: new Set(),
      deployOptions: [
        { label: '全球(不含大陆)', value: 'overseas' },
        { label: '全球', value: 'global' },
        { label: '仅中国大陆', value: 'domestic' }
      ],
      internalLinkKeywords: '',
      internalLinkLoading: false,
      internalLinkList: [],
      internalLinkTotal: 0,
      internalLinkSize: 10,
      internalLinkPage: 1,
      internalLinkDetailVisible: false,
      internalLinkDetailLoading: false,
      internalLinkDetailForm: {
        id: '',
        domain: this.domain,
        keyword: ''
      },
      internalLinkDetailRules: {
        keyword: [
          { required: true, message: '本项不能为空', trigger: 'commit' }
        ]
      },
      uploadInternalLinkVisible: false,
      uploadInternalLinkLoading: false,
      uploadInternalLinkFileList: []
    }
  },
  created() {
    this.domain = this.$route.params.domain;
    this.lang = this.$route.query.lang || 'en';
    this.init();
    for (let i = 0; i < 24; i++) {
      const hour = String(i).padStart(2, '0');
      const value = `${hour}:00`;
      this.timingOptions.push({
        label: value,
        value: value
      });
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    tabClick(tab, event) {
      switch (tab.name) {
        case 'basic':
          this.init();
          break;
        case 'blades':
          this.getBladesList();
          break;
        case 'pages':
          this.getPagesList();
          break;
        case 'media':
          this.getMedia();
          break;
        case 'products':
          this.queryProductsList();
          break;
        case 'news':
          this.queryNewsList();
          break;
        case 'supplements':
          this.querySupplementsList();
          break;
        case 'contents':
          this.queryContentsList();
          break;
        case 'seo':
          this.getSeo();
          break;
        case 'internationalization':
          this.getMultilingualManguages();
          break;
        case 'partners':
          this.getPartners();
          break;
        case 'knowledge':
          this.queryKnowledgeList();
          break;
        case 'deploy':
          this.queryDeploy();
          this.$nextTick(() => {
            this.$refs.multipleTable.doLayout();
          });
          break;
        case 'internal_link':
          this.queryInternalLinkList();
          break;
      }
    },
    async init() {
      await this.$axios.get(`/websites/backend/detail?domain=${this.domain}&lang=${this.lang}`).then((response) => {
        this.loading = false;
        if (response.data.code === 200) {
          this.website = response.data.data
        }
      })
      await this.$axios.get(`/websites/backend/salers`).then((response) => {
        if (response.data.code === 200) {
          this.salers = response.data.data
        }
      })
      await this.$axios.get(`/websites/backend/languages?domain=${this.domain}`).then((response) => {
        if (response.data.code === 200) {
          this.languages = response.data.data
        }
      })
    },
    copy(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    },
    view(url) {
      const windowFeatures = 'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,fullscreen=yes,channelmode=yes';
      window.open('http://' + url, '_blank', windowFeatures);
    },
    saveTurningEmailPool() {
      this.$confirm('保存后网站主邮箱将会立即生效, 确定吗', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.store();
      })
    },
    store() {
      this.$axios.post(`/websites/backend/store`, this.website).then((response) => {
        if (response.data.code === 200) {
          this.editTurningEmailPoolVisible = false;
          this.init();
          this.$message({
            message: '已保存',
            type: 'success'
          });
        }
      }).catch();
    },
    deleteTurningEmailPool() {
      this.$confirm('确定删除轮换邮箱吗? 此操作不可恢复', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(`/websites/backend/delete_turning_email_pool`, {
          web_id: this.website.id
        }).then((response) => {
          if (response.data.code === 200) {
            this.init();
            this.$message({
              message: '已保存',
              type: 'success'
            });
          }
        })
      });
    },
    deleteWebsite() {
      const l = this.lang;
      const notice = (l === 'en' || l === '' || l === null || l === undefined) ? '删除后网站将无法访问, 并且多语种网站会一并删除, 此操作不可恢复, 确定吗?' : ('此操作将删除' + this.languages[l] + '站, 其余站点不影响, 此操作不可恢复, 确定吗?');
      this.$confirm(notice, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const n = {
          domain: this.domain,
          lang: l
        }
        this.$axios.post('/websites/backend/delete', n).then((response) => {
          const message = (l === 'en' || l === '' || l === null || l === undefined) ? this.domain : (l + '.' + this.domain)
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: message + '已经删除',
              type: 'success'
            });
            this.$router.push({
              name: 'websites_list'
            });
          }
        })
      }).catch();
    },
    refreshCDN() {
      this.$axios.post('/websites/backend/cdn/refresh', {
        domain: this.domain,
        type: 'master'
      }).then((response) => {
        if (response.data.code === 200) {
          this.$notify({
            title: '刷新成功',
            message: '今日剩余次数:' + response.data.data,
            type: 'success'
          });
        }
      })
    },
    refreshCDNV2(row) {
      let status = row.status;
      if (status !== '已完成') {
        this.$message({
          type: 'error',
          message: '当前状态不可刷新'
        })
      } else {
        let domain = row.subdomain === '@' ? this.domain : (row.subdomain + '.' + this.domain);
        this.$axios.post('/websites/backend/cdn/refresh', {
          domain: domain,
          type: 'normal'
        }).then((response) => {
          if (response.data.code === 200) {
            this.$notify({
              title: '刷新成功',
              message: '今日剩余次数:' + response.data.data,
              type: 'success'
            });
          }
        })
      }
    },
    pageSettings() {
      this.pageSettingsVisible = true;
      this.pageSettingsLoading = true;
      this.$axios.get(`/websites/backend/pages?domain=${this.domain}&lang=${this.lang}`).then((response) => {
        this.pageSettingsLoading = false;
        if (response.data.code === 200) {
          this.pageSettingsData = response.data.data.data;
          this.defaultExpandedKeys = response.data.data.default_checked_keys;
          this.defaultCheckedKeys = response.data.data.default_checked_keys;
        }
      })
    },
    footerPageSettings() {
      this.footerPageSettingsVisible = true;
      this.footerPageSettingsLoading = true;
      this.$axios.get(`/websites/backend/pages/footer?domain=${this.domain}&lang=${this.lang}`).then((response) => {
        this.footerPageSettingsLoading = false;
        if (response.data.code === 200) {
          this.footerPageSettingsData = response.data.data.data;
          this.fooyerDefaultExpandedKeys = response.data.data.default_checked_keys;
          this.footerDefaultCheckedKeys = response.data.data.default_checked_keys;
        }
      })
    },
    savePageSettings() {
      const checkedNodes = this.$refs.pageSettingsData.getCheckedNodes();
      const allNodes = [];
      const addedNodeIds = new Set();
      checkedNodes.forEach(node => {
        this.addNodeAndParents(node, allNodes, addedNodeIds);
      });
      this.$confirm('确定保存新的栏目设置吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.pageSettingsLoading = true;
        const n = {
          domain: this.domain,
          lang: this.lang,
          nodes: allNodes
        }
        this.$axios.post('/websites/backend/pages/save', n).then((response) => {
          this.pageSettingsLoading = false;
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: '保存成功',
              type: 'success'
            });
          }
        })
      }).catch();
    },
    addNodeAndParents(node, allNodes, addedNodeIds) {
      const nodeInstance = this.$refs.pageSettingsData.getNode(node);
      if (nodeInstance && nodeInstance.parent && nodeInstance.parent.data) {
        const parentNode = nodeInstance.parent.data;
        const parentNodeInstance = this.$refs.pageSettingsData.getNode(parentNode);
        if (parentNodeInstance && (parentNodeInstance.checked || parentNodeInstance.indeterminate)) {
          this.addNodeAndParents(parentNode, allNodes, addedNodeIds);
        }
      }
      if (!addedNodeIds.has(node.id)) {
        allNodes.push(node);
        addedNodeIds.add(node.id);
      }
    },
    saveFooterPageSettings() {
      const checkedNodes = this.$refs.footerPageSettingsData.getCheckedNodes();
      const allNodes = [];
      const addedNodeIds = new Set();
      checkedNodes.forEach(node => {
        this.addNodeAndParentsFooter(node, allNodes, addedNodeIds);
      });
      this.$confirm('确定保存新的栏目设置吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.footerPageSettingsLoading = true;
        const n = {
          domain: this.domain,
          lang: this.lang,
          nodes: allNodes
        }
        this.$axios.post('/websites/backend/pages/save_footer', n).then((response) => {
          this.footerPageSettingsLoading = false;
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: '保存成功',
              type: 'success'
            });
          }
        })
      }).catch();
    },
    addNodeAndParentsFooter(node, allNodes, addedNodeIds) {
      const nodeInstance = this.$refs.footerPageSettingsData.getNode(node);
      if (nodeInstance && nodeInstance.parent && nodeInstance.parent.data) {
        const parentNode = nodeInstance.parent.data;
        const parentNodeInstance = this.$refs.footerPageSettingsData.getNode(parentNode);
        if (parentNodeInstance && (parentNodeInstance.checked || parentNodeInstance.indeterminate)) {
          this.addNodeAndParents(parentNode, allNodes, addedNodeIds);
        }
      }
      if (!addedNodeIds.has(node.id)) {
        allNodes.push(node);
        addedNodeIds.add(node.id);
      }
    },
    async logoSettings() {
      this.logoInfo = {}
      this.logoSettingsVisible = true;
      await this.$axios.get(`/websites/backend/logo?domain=${this.domain}`).then((response) => {
        if (response.data.code === 200) {
          this.logoInfo = response.data.data;
        }
      })
    },
    uploadLogoSuccess(response) {
      if (response.code === 200) {
        this.$notify({
          title: 'success',
          message: '上传成功',
          type: 'success'
        })
        this.logoSettings();
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    async colorSettings() {
      this.siteColors = {
        first: '',
        second: '',
        third: ''
      }
      this.colorSettingsVisible = true;
      this.$axios.get(`/websites/backend/colors?domain=${this.domain}`).then((response) => {
        if (response.data.code === 200) {
          this.siteColors = response.data.data;
        }
      }).catch();
    },
    saveColorSettings() {
      const d = {
        domain: this.domain,
        colors: this.siteColors
      };
      this.$axios.post(`/websites/backend/colors/save`, d).then((response) => {
        if (response.data.code === 200) {
          this.$notify({
            title: '操作成功',
            message: '新的色彩已经应用',
            type: 'success'
          });
        }
      }).catch();
    },
    getBladesList() {
      this.bladesloading = true;
      this.$axios.get(`/websites/backend/blades?domain=${this.domain}`).then((response) => {
        this.bladesloading = false;
        if (response.data.code === 200) {
          this.bladesList = response.data.data;
        }
      })
    },
    useBlade(item) {
      this.$confirm('此操作将替换网站模板, 并且将应用本模板默认初始样式(包括logo等图片), 此操作不可逆转, 确定执行吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.bladesloadingText = '正在应用模板, 请勿关闭或切换页面';
        this.bladesloading = true;
        this.$axios.post('/websites/backend/blades/use', {
          id: item.id,
          domain: this.domain
        }).then((response) => {
          this.bladesloading = false;
          if (response.data.code === 200) {
            this.getBladesList();
            this.$notify({
              title: '操作成功',
              message: item.title + ' 已经应用',
              type: 'success'
            });
          }
        })
      }).catch();
    },
    getPagesList() {
      this.pagesLoading = true;
      this.$axios.get(`/websites/backend/pages?domain=${this.domain}&type=flatten&lang=${this.lang}`).then((response) => {
        this.pagesLoading = false;
        if (response.data.code === 200) {
          this.pagesList = response.data.data.data;
        }
      })
    },
    togglePagesStatus(row, index) {
      this.$axios.post('/websites/backend/pages/toggle_status', {
        id: row.id,
        lang: this.lang,
        status: row.status
      })
    },
    async editPage(row) {
      this.pagesDetailTitle = row.title;
      this.pagesDetailForm = {
        keywords: '',
        description: '',
        og_title: '',
        og_description: '',
        content: ''
      }
      this.pagesDetailVisible = true;
      this.pagesDetailLoading = true;
      await this.$axios.get(`/websites/backend/pages/detail?id=${row.id}&lang=${this.lang}`).then((response) => {
        this.pagesDetailLoading = false;
        if (response.data.code === 200) {
          this.pagesDetailForm = response.data.data;
        }
      })
    },
    savePagesDetail() {
      this.pagesDetailLoading = true;
      this.pagesDetailForm.lang = this.lang
      this.$axios.post(`/websites/backend/pages/save_detail`, this.pagesDetailForm).then((response) => {
        this.pagesDetailLoading = false;
        if (response.data.code === 200) {
          this.getPagesList();
          this.pagesDetailVisible = false;
          this.$message({
            message: '已保存',
            type: 'success'
          });
        }
      }).catch();
    },
    getMedia() {
      this.mediaList = [];
      this.medialoading = true;
      this.$axios.get(`/websites/backend/media?domain=${this.domain}&type=${this.mediaType}`).then((response) => {
        this.medialoading = false;
        if (response.data.code === 200) {
          this.mediaList = response.data.data.map(item => ({
            ...item,
            url: item.url + '?' + new Date().getTime()
          }));
        }
      })
    },
    submitUpload() {
      this.$refs.uploadMedia.submit();
    },
    deleteMedia(name, type) {
      let notice = '确定要删除' + name + '吗? 此操作不可恢复'
      this.$confirm(notice, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(`websites/backend/media/delete`, {
          domain: this.domain,
          name: name,
          type: type
        }).then((response) => {
          if (response.data.code === 200) {
            this.getMedia();
            this.$notify({
              title: '操作成功',
              message: name + '已删除',
              type: 'success'
            });
          }
        })
      }).catch(() => {
      });
    },
    storeRenameMedia(index, type) {
      let obj = this.mediaList[index];
      this.$axios.post(`websites/backend/media/rename`, {
        domain: this.domain,
        name: this.renamedMediaName,
        url: obj.url,
        type: type
      }).then((response) => {
        if (response.data.code === 200) {
          this.renamedMediaName = '';
          this.getMedia();
          this.$message({
            message: '已保存',
            type: 'success'
          });
        }
      })
    },
    queryProductsList(search = false) {
      this.productsLoading = true;
      let current_page = search === true ? 1 : this.productsPage;
      let keywords = this.productsKeywords;
      let size = this.productsSize;
      this.$axios.get('/websites/backend/products', {
        params: {
          domain: this.domain,
          lang: this.lang,
          keywords: keywords,
          page: current_page,
          size: size
        }
      }).then((response) => {
        this.productsLoading = false;
        if (response.data.code === 200) {
          this.productsList = response.data.data.data;
          this.productsTotal = response.data.data.total;
        }
      })
    },
    changeProductsSize(val) {
      this.productsSize = val;
      this.queryProductsList();
    },
    currentProductsChange(val) {
      this.productsPage = val;
      this.queryProductsList();
    },
    toggleProductStatus(row, index) {
      let notice = row.status ? '确定开启吗?' : '关闭后产品将不在本站显示, 确定吗?';
      let message = row.status ? '开启' : '关闭';
      this.$confirm(notice, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/products/toggle_status', {
          lang: this.lang,
          id: row.id,
          status: row.status
        }).then((response) => {
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: row.product_name + ' 已经' + message,
              type: 'success'
            });
          }
        })
      }).catch(() => {
        this.productsList[index].status = !row.status;
      });
    },
    async getProductDetail(row) {
      this.productDetailDiaTitle = row.product_name;
      this.productDetailLoadingText = '正在加载, 请稍候';
      this.productDetailVisible = true;
      this.productDetailLoading = true;
      await this.$axios.get(`/websites/backend/products/categories?domain=${this.domain}&lang=${this.lang}`).then((response) => {
        this.productCategoriesLoading = false;
        if (response.data.code === 200) {
          this.productCategoriesOptions = response.data.data.normal;
        }
      })
      await this.$axios.get(`/websites/backend/products/detail?id=${row.id}&lang=${this.lang}`).then((response) => {
        this.productDetailLoading = false;
        if (response.data.code === 200) {
          this.productDetail = response.data.data;
        }
      })
    },
    deleteProduct(row) {
      this.$confirm('确定删除吗? 此操作不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/products/delete', {
          id: row.id,
          lang: this.lang
        }).then((response) => {
          if (response.data.code === 200) {
            this.queryProductsList();
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          }
        })
      }).catch(() => { });
    },
    addProperty() {
      this.productDetail.properties.push({
        id: '',
        product_id: this.productDetail.id,
        property_key: '',
        property_value: ''
      });
    },
    removeProperty(index) {
      this.productDetail.properties.splice(index, 1);
    },
    saveProductDetail() {
      this.productDetailLoadingText = '正在保存, 请稍候';
      this.productDetailLoading = true;
      this.productDetail.lang = this.lang
      this.$axios.post(`/websites/backend/products/save`, this.productDetail).then((response) => {
        if (response.data.code === 200) {
          this.productDetailLoading = false;
          this.queryProductsList();
          // this.productDetailVisible = false;
          this.$message({
            message: '已保存',
            type: 'success'
          });
        }
      }).catch();
    },
    async addProduct() {
      this.productDetailDiaTitle = '录入产品';
      this.productDetailVisible = true;
      await this.$axios.get(`/websites/backend/products/categories?domain=${this.domain}&type=add`).then((response) => {
        this.productCategoriesLoading = false;
        if (response.data.code === 200) {
          this.productCategoriesOptions = response.data.data.normal;
          this.productCategoriesData = response.data.data.tree;
        }
      })
      this.productDetail = {
        product: '',
        cas: '',
        category_id: '',
        type: '',
        url: '',
        shape: '',
        specifications: '',
        keywords: '',
        description: '',
        og_title: '',
        og_description: '',
        properties: [],
        packing_storage: {
          packing: '',
          storage: '',
          shipping: ''
        },
        generals: [],
        faqs: []
      };
    },
    uploadProducts() {
      this.uploadProductsFileList = [];
      this.uploadProductsVisible = true;
    },
    submitUploadProducts() {
      this.uploadProductsLoading = true;
      this.$refs.uploadProducts.submit();
    },
    uploadProductsSuccess(response) {
      this.uploadProductsFileList = [];
      if (response.code === 200) {
        this.uploadProductsLoading = false;
        this.uploadProductsVisible = false;
        this.$notify({
          title: 'success',
          message: '上传成功',
          type: 'success'
        })
        this.queryProductsList();
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    downloadProductsLinks() {
      window.location.href = this.$axios.defaults.baseURL + `websites/backend/products/download_products_links?domain=${this.domain}`;
    },
    headerDbClick(data) {
      this.currentValue = data.category
      this.$set(data, 'isEdit', true)
      this.$nextTick(() => {
        this.$refs[data.id] && this.$refs[data.id].focus()
      })
    },
    handleInputBlur(event, data) {
      const inputValue = event.target.value.trim()
      if (inputValue === '') {
        this.$message({
          type: 'warning',
          message: '分类名称不能为空,请重新输入'
        })
        this.$set(data, 'isEdit', false)
      } else if (inputValue === data.category) {
        this.$set(data, 'isEdit', false)
      } else {
        this.$set(data, 'isEdit', false)
        data.category = inputValue
      }
      this.currentValue = '';
      this.saveProductCategories(this.productCategoriesData)
    },
    handleDragEnd(draggingNode, dropNode, dropType, ev) {
      this.saveProductCategories(this.productCategoriesData)
    },
    saveProductCategories(tree) {
      this.productCategoriesLoading = true;
      const data = {
        tree: tree,
        lang: this.lang
      }
      this.$axios.post(`/websites/backend/products/categories_save`, data).then((response) => {
        this.productCategoriesLoading = false;
        if (response.data.code === 200) {
          this.$message({
            type: 'success',
            message: '已保存'
          })
        }
      })
    },
    handleMouseEnter(id) {
      this.hoveredNodeId = id;
    },
    handleMouseLeave() {
      this.hoveredNodeId = null;
    },
    toggleCategoryStatus(row) {
      const data = {
        lang: this.lang,
        id: row.id,
        status: row.status
      }
      this.$axios.post(`/websites/backend/products/categories_toggle_status`, data).then((response) => {
        if (response.data.code === 200) {
          row.status = 1 - row.status;
        }
      })
    },
    saveAddProductCategories() {
      let category = this.productCategoriesForm.category;
      let parent_id = this.productCategoriesForm.parent_id || 0;
      if (category === null || category === '') {
        this.$message({
          type: 'error',
          message: '类名不能为空'
        })
      } else {
        const data = {
          domain: this.domain,
          category: category,
          parent_id: parent_id
        }
        this.$axios.post(`/websites/backend/products/add_category`, data).then((response) => {
          if (response.data.code === 200) {
            this.manageProductsCategories()
          }
        })
      }
    },
    queryNewsList(search = false) {
      this.newsLoading = true;
      let current_page = search === true ? 1 : this.newsPage;
      let keywords = this.newsKeywords;
      let size = this.newsSize;
      this.$axios.get('/websites/backend/news', {
        params: {
          domain: this.domain,
          keywords: keywords,
          page: current_page,
          size: size
        }
      }).then((response) => {
        this.newsLoading = false;
        if (response.data.code === 200) {
          this.newsList = response.data.data.data;
          this.newsTotal = response.data.data.total;
        }
      })
    },
    changeNewsSize(val) {
      this.newsSize = val;
      this.queryNewsList();
    },
    currentNewsChange(val) {
      this.newsPage = val;
      this.queryNewsList();
    },
    toggleNewsStatus(row, index) {
      let notice = row.status ? '确定开启吗?' : '关闭后新闻将不在本站显示, 确定吗?';
      let message = row.status ? '开启' : '关闭';
      this.$confirm(notice, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/news/toggle_status', {
          id: row.id,
          status: row.status
        }).then((response) => {
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: row.title + ' 已经' + message,
              type: 'success'
            });
          }
        })
      }).catch(() => {
        this.newsList[index].status = !row.status;
      });
    },
    addNews() {
      this.newsDetailForm = {
        domain: this.domain,
        title: '',
        url: '',
        content: ''
      };
      this.newsDetailTitle = '新建';
      this.newsDetailVisible = true;
    },
    getNewsDetail(row) {
      this.newsDetailVisible = true;
      this.newsDetailLoading = true;
      this.newsDetailTitle = '编辑';
      this.$axios.get(`/websites/backend/news/detail?id=${row.id}`).then((response) => {
        this.newsDetailLoading = false;
        if (response.data.code === 200) {
          this.newsDetailForm = response.data.data;
        }
      })
    },
    saveNewsDetail() {
      this.$refs.newsDetailForm.validate(valid => {
        if (valid) {
          this.newsDetailLoading = true;
          this.$axios.post(`/websites/backend/news/save`, this.newsDetailForm).then((response) => {
            this.newsDetailLoading = false;
            if (response.data.code === 200) {
              this.newsDetailForm = {
                title: '',
                url: '',
                content: ''
              };
              this.queryNewsList();
              this.newsDetailVisible = false;
              this.$message({
                message: '已保存',
                type: 'success'
              });
            }
          }).catch();
        }
      })
    },
    deleteNews(row) {
      this.$confirm('确定删除吗? 此操作不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/news/delete', {
          id: row.id
        }).then((response) => {
          if (response.data.code === 200) {
            this.queryNewsList();
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          }
        })
      }).catch(() => { });
    },
    querySupplementsList(search = false) {
      this.supplementsLoading = true;
      let current_page = search === true ? 1 : this.supplementsPage;
      let keywords = this.supplementsKeywords;
      let size = this.supplementsSize;
      this.$axios.get('/websites/backend/supplements', {
        params: {
          domain: this.domain,
          keywords: keywords,
          page: current_page,
          size: size
        }
      }).then((response) => {
        this.supplementsLoading = false;
        if (response.data.code === 200) {
          this.supplementsList = response.data.data.data;
          this.supplementsTotal = response.data.data.total;
          this.supplementsProgress = response.data.data.progress;
        }
      })
    },
    changeSupplementsSize(val) {
      this.supplementsSize = val;
      this.querySupplementsList();
    },
    currentSupplementsChange(val) {
      this.supplementsPage = val;
      this.querySupplementsList();
    },
    toggleSupplementsStatus(row, index) {
      let notice = row.status ? '确定开启吗?' : '关闭后新闻将不在本站显示, 确定吗?';
      let message = row.status ? '开启' : '关闭';
      this.$confirm(notice, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/supplements/toggle_status', {
          id: row.id,
          status: row.status
        }).then((response) => {
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: row.title + ' 已经' + message,
              type: 'success'
            });
          }
        })
      }).catch(() => {
        this.supplementsList[index].status = !row.status;
      });
    },
    addSupplements() {
      this.supplementsDetailForm = {
        domain: this.domain,
        title: '',
        url: '',
        content: '',
        weight_value: 0
      };
      this.supplementsDetailTitle = '新建';
      this.supplementsDetailVisible = true;
    },
    getSupplementsDetail(row) {
      this.supplementsDetailVisible = true;
      this.supplementsDetailLoading = true;
      this.supplementsDetailTitle = '编辑';
      this.$axios.get(`/websites/backend/supplements/detail?id=${row.id}`).then((response) => {
        this.supplementsDetailLoading = false;
        if (response.data.code === 200) {
          this.supplementsDetailForm = response.data.data;
        }
      })
    },
    deleteSupplement(row) {
      this.$confirm('确定删除吗? 此操作不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/supplements/delete', {
          id: row.id
        }).then((response) => {
          if (response.data.code === 200) {
            this.querySupplementsList();
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          }
        })
      }).catch(() => { });
    },
    saveSupplementsDetail() {
      this.$refs.supplementsDetailForm.validate(valid => {
        if (valid) {
          this.supplementsDetailLoading = true;
          this.$axios.post(`/websites/backend/supplements/save`, this.supplementsDetailForm).then((response) => {
            this.supplementsDetailLoading = false;
            if (response.data.code === 200) {
              this.supplementsDetailForm = {
                title: '',
                url: '',
                content: '',
                weight_value: 0
              };
              this.querySupplementsList();
              this.supplementsDetailVisible = false;
              this.$message({
                message: '已保存',
                type: 'success'
              });
            }
          }).catch();
        }
      })
    },
    uploadSupplements() {
      this.uploadSupplementsFileList = [];
      this.uploadSupplementsVisible = true;
    },
    submitUploadSupplements() {
      this.uploadSupplementsLoading = true;
      this.$refs.uploadSupplements.submit();
    },
    uploadSupplementsSuccess(response) {
      this.uploadSupplementsFileList = [];
      if (response.code === 200) {
        this.uploadSupplementsLoading = false;
        this.uploadSupplementsVisible = false;
        this.$notify({
          title: 'success',
          message: '上传成功',
          type: 'success'
        })
        this.querySupplementsList();
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    async supplementsSettings() {
      this.supplementsSettingsVisible = true;
      this.supplementsSettingsLoading = true;
      this.supplementsSettingsLoadingText = '正在加载, 请稍后';
      await this.$axios.get(`/websites/backend/supplements/get_settings?domain=${this.domain}`).then((response) => {
        if (response.data.code === 200) {
          this.supplementsSettingsLoading = false;
          this.supplementsSettingsForm = {
            quantity: response.data.data.quantity,
            timing: response.data.data.timing
          }
        }
      })
    },
    saveSupplementsSettings() {
      const data = {
        domain: this.domain,
        quantity: this.supplementsSettingsForm.quantity,
        timing: this.supplementsSettingsForm.timing
      }
      this.$refs.supplementsSettingsForm.validate(valid => {
        if (valid) {
          this.supplementsSettingsLoading = true;
          this.supplementsSettingsLoadingText = '正在保存, 请稍后';
          this.$axios.post(`/websites/backend/supplements/save_settings`, data).then((response) => {
            this.supplementsSettingsLoading = false;
            if (response.data.code === 200) {
              this.querySupplementsList();
              this.supplementsSettingsVisible = false;
              this.$notify({
                message: '已保存',
                type: 'success'
              });
            }
          }).catch();
        }
      })
    },
    async blurSaveSupplementsWeightValue(row, prop) {
      if (row[prop] > 100) {
        row[prop] = 100;
      } else if (row[prop] < 0) {
        row[prop] = 0;
      } else if (isNaN(row[prop])) {
        row[prop] = 0;
      }
      const data = {
        id: row.id,
        weight_value: row[prop]
      }
      this.$axios.post(`/websites/backend/supplements/update_weight_value`, data).then().catch();
    },
    getSeo() {
      this.seoLoading = true;
      this.$axios.get(`/websites/backend/seo?domain=${this.domain}&lang=${this.lang}`).then((response) => {
        this.seoLoading = false;
        if (response.data.code === 200) {
          this.seoForm = response.data.data;
          this.seoList = response.data.data.seo_list;
        }
      })
    },
    saveWebsiteSeo() {
      this.seoLoading = true;
      this.seoForm.lang = this.lang;
      this.$axios.post(`/websites/backend/seo/save`, this.seoForm).then((response) => {
        if (response.data.code === 200) {
          this.getSeo();
          this.$message({
            message: '已保存',
            type: 'success'
          });
        }
      }).catch();
    },
    seoRowClassName({ row, rowIndex }) {
      if (row.used === true) {
        return 'success-row';
      }
    },
    uploadSitemapSuccess(response, file, fileList) {
      if (response.code === 200) {
        this.getSeo();
        this.$refs.uploadSitemapRef.clearFiles();
      } else {
        this.$message.error(`上传失败, 200`);
      }
    },
    uploadSitemapError(error, file, fileList) {
      this.$message.error(`上传失败`);
    },
    async manageProductsCategories() {
      this.manageProductsCategoriesVisible = true;
      this.productCategoriesLoading = true;
      this.productCategoriesForm = {
        category: '',
        parent_id: ''
      }
      await this.$axios.get(`/websites/backend/products/categories?domain=${this.domain}`).then((response) => {
        this.productCategoriesLoading = false;
        if (response.data.code === 200) {
          this.productCategoriesOptions = response.data.data.normal;
          this.productCategoriesData = response.data.data.tree;
        }
      })
    },
    async clearProducts() {
      this.$confirm('确定清空所有产品吗? 此操作不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在清理产品, 请稍候',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$axios.post('/websites/backend/products/clear', {
          lang: this.lang,
          domain: this.domain
        }).then((response) => {
          loading.close();
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: '所有产品已经清除',
              type: 'success'
            });
            this.queryProductsList();
          }
        })
      })
    },
    useSeo(row) {
      this.$confirm('确定使用此方案吗? 此方案不会影响已经手动修改过seo信息的条目', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/seo/use', {
          id: row.id,
          domain: this.domain
        }).then((response) => {
          if (response.data.code === 200) {
            this.getSeo();
            this.$notify({
              title: '操作成功',
              message: row.id + '号方案已经应用',
              type: 'success'
            });
          }
        })
      }).catch();
    },
    getPartners() {
      this.partnersList = [];
      this.partnersLoading = true;
      this.$axios.get(`/websites/backend/partners?domain=${this.domain}`).then((response) => {
        this.partnersLoading = false;
        if (response.data.code === 200) {
          this.partnersList = response.data.data;
        }
      })
    },
    clearAllPartners() {
      this.$confirm('确定清空所有合作伙伴吗? 此操作不能还原', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/partners/clear', {
          domain: this.domain
        }).then((response) => {
          if (response.data.code === 200) {
            this.getPartners();
            this.$notify({
              title: '操作成功',
              message: '合作伙伴已全部清除',
              type: 'success'
            });
          }
        })
      }).catch();
    },
    submitPartnersUpload() {
      this.$refs.uploadPartners.submit();
    },
    updateProductDetailImage(response) {
      let name = response.data.original.data.name;
      let url = response.data.original.data.url;
      setTimeout(() => {
        this.productDetail.cover = name;
        this.productDetail.cover_src = url;
        console.log(this.productDetail);
      }, 0);
    },
    async getMultilingualManguages() {
      this.multilingualLanguagesList = [];
      this.multilingualLanguagesLoading = true;
      this.$axios.get(`/websites/backend/languages/multilingual?domain=${this.domain}`).then((response) => {
        this.multilingualLanguagesLoading = false;
        if (response.data.code === 200) {
          this.multilingualLanguagesList = response.data.data;
        }
      })
    },
    deleteMultilingualLanguages(row) {
      this.$confirm('确定删除此语种吗? 此操作不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/languages/delete', {
          id: row.id
        }).then((response) => {
          if (response.data.code === 200) {
            this.getMultilingualManguages();
            this.$notify({
              title: '操作成功',
              message: row.lang_show + '站已经删除',
              type: 'success'
            });
          }
        })
      }).catch();
    },
    manageMultilingualLanguages(row) {
      this.$router.push({
        name: 'websites_detail',
        params: {
          domain: this.domain
        },
        query: {
          lang: row.lang
        }
      });
      setTimeout(() => {
        window.location.reload()
      }, 0);
    },
    redoMultilingualLanguages(row) {
      this.redoMultilingualLanguagesForm = {
        domain: this.domain,
        type: '',
        action: '补充',
        lang: row.lang
      }
      this.redoMultilingualLanguagesTitle = "小语种: " + row.lang_show + "(" + row.lang + ")";
      this.redoMultilingualLanguagesVisible = true;
    },
    saveRedoMultilingualLanguages() {
      if (!this.redoMultilingualLanguagesForm.type) {
        this.$message({
          message: '请选择类型',
          type: 'error'
        });
        return false;
      }
      let str = "正在进行 " + this.redoMultilingualLanguagesForm.action + this.redoMultilingualLanguagesForm.type + " 操作, 确定吗?";
      this.$confirm(str, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.redoMultilingualLanguagesLoading = true;
        this.$axios.post('/websites/backend/languages/redo', this.redoMultilingualLanguagesForm).then((response) => {
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: '操作成功',
              type: 'success'
            });
            this.redoMultilingualLanguagesVisible = false;
          }
        })
        this.redoMultilingualLanguagesLoading = false;
      })
    },
    async addMultilingualLanguages() {
      this.addMultilingualLanguagesVisible = true;
      this.addMultilingualLanguagesLoadingText = '正在加载, 请稍候';
      this.addMultilingualLanguagesLoading = true;
      this.$axios.get(`/websites/backend/languages/list?domain=${this.domain}`).then((response) => {
        this.addMultilingualLanguagesLoading = false;
        if (response.data.code === 200) {
          this.addMultilingualLanguagesFormCheckers = response.data.data;
        }
      })
    },
    toggleMultilingualLanguagesStatus(row, index) {
      this.$axios.post('/websites/backend/languages/toggle_status', {
        id: row.id,
        lang: this.lang,
        status: row.status
      })
    },
    saveAddMultilingualLanguages() {
      this.addMultilingualLanguagesLoadingText = '正在保存, 请稍候';
      this.addMultilingualLanguagesLoading = true;
      const data = {
        domain: this.domain,
        checkers: this.addMultilingualLanguagesForm.checkedValues
      }
      this.$axios.post('/websites/backend/languages/save', data).then((response) => {
        this.addMultilingualLanguagesLoading = false;
        if (response.data.code === 200) {
          this.addMultilingualLanguagesVisible = false;
          this.addMultilingualLanguagesForm = {
            checkedValues: []
          }
          this.getMultilingualManguages();
          this.$notify({
            title: '操作成功',
            message: '保存成功',
            type: 'success'
          });
        }
      })
    },
    backToEnglishVersion() {
      this.$router.push({
        name: 'websites_detail',
        params: {
          domain: this.domain
        }
      });
      setTimeout(() => {
        window.location.reload()
      }, 0);
    },
    queryKnowledgeList(search = false) {
      this.knowledgeLoading = true;
      let current_page = search === true ? 1 : this.knowledgePage;
      let keywords = this.knowledgeKeywords;
      let size = this.knowledgeSize;
      this.$axios.get('/websites/backend/knowledges', {
        params: {
          domain: this.domain,
          type: this.knowledgeType,
          keywords: keywords,
          page: current_page,
          size: size
        }
      }).then((response) => {
        this.knowledgeLoading = false;
        if (response.data.code === 200) {
          this.knowledgeList = response.data.data.data;
          this.knowledgeTotal = response.data.data.total;
        }
      })
    },
    changeKnowledgeSize(val) {
      this.knowledgeSize = val;
      this.queryKnowledgeList();
    },
    currentKnowledgeChange(val) {
      this.knowledgePage = val;
      this.queryKnowledgeList();
    },
    addKnowledge() {
      this.knowledgeDetailForm = {
        domain: this.domain,
        type: this.knowledgeType,
        word: '',
        is_regean: false
      };
      this.knowledgeDetailTitle = '添加' + this.knowledgeType;
      this.knowledgeDetailVisible = true;
    },
    getKnowledgeDetail(row) {
      this.knowledgeDetailVisible = true;
      this.knowledgeDetailLoading = true;
      this.knowledgesDetailTitle = '编辑';
      this.$axios.get(`/websites/backend/knowledges/detail?id=${row.id}&type=${this.knowledgeType}`).then((response) => {
        this.knowledgeDetailLoading = false;
        if (response.data.code === 200) {
          this.knowledgeDetailForm = response.data.data;
        }
      })
    },
    deleteKnowledge(row) {
      this.$confirm('确定删除吗? 此操作不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/knowledges/delete', {
          id: row.id,
          type: this.knowledgeType,
          batch: row.batch
        }).then((response) => {
          if (response.data.code === 200) {
            this.queryKnowledgeList();
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          }
        })
      }).catch(() => { });
    },
    saveKnowledgeDetail() {
      this.$refs.knowledgeDetailForm.validate(valid => {
        if (valid) {
          this.supplementsDetailLoading = true;
          this.$axios.post(`/websites/backend/knowledges/save`, this.knowledgeDetailForm).then((response) => {
            this.knowledgeDetailLoading = false;
            if (response.data.code === 200) {
              this.knowledgeDetailForm = {
                word: '',
                is_regean: false
              };
              this.queryKnowledgeList();
              this.knowledgeDetailVisible = false;
              this.$message({
                message: '已保存',
                type: 'success'
              });
            }
          }).catch();
        }
      })
    },
    uploadKnowledge() {
      this.uploadKnowledgeFileList = [];
      this.uploadKnowledgeVisible = true;
    },
    submitUploadKnowledge() {
      this.uploadKnowledgeLoading = true;
      this.$refs.uploadKnowledge.submit();
    },
    uploadKnowledgeSuccess(response) {
      this.uploadKnowledgeFileList = [];
      if (response.code === 200) {
        this.uploadKnowledgeLoading = false;
        this.uploadKnowledgeVisible = false;
        this.$notify({
          title: 'success',
          message: '上传成功',
          type: 'success'
        })
        this.queryKnowledgeList();
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    queryContentsList() {
      this.contentsLoading = true;
      let current_page = this.contentsPage;
      let size = this.contentsSize;
      let type = this.contentsType;
      this.$axios.get('/websites/backend/contents', {
        params: {
          domain: this.domain,
          lang: this.lang,
          type: type,
          page: current_page,
          size: size
        }
      }).then((response) => {
        this.contentsLoading = false;
        if (response.data.code === 200) {
          this.contentsList = response.data.data.data;
          this.contentsTotal = response.data.data.total;
        }
      })
    },
    changeContentsSize(val) {
      this.contentsSize = val;
      this.queryContentsList();
    },
    currentContentsChange(val) {
      this.contentsPage = val;
      this.queryContentsList();
    },
    editContents(row) {
      this.contentsDetailVisible = true;
      this.contentsDetailLoading = true;
      this.contentsDetailTitle = '编辑';
      this.$axios.get(`/websites/backend/contents/detail?id=${row.id}`).then((response) => {
        this.contentsDetailLoading = false;
        if (response.data.code === 200) {
          this.contentsDetailForm = response.data.data;
        }
      })
    },
    saveContentsDetail() {
      this.$refs.contentsDetailForm.validate(valid => {
        if (valid) {
          this.contentsDetailLoading = true;
          this.$axios.post(`/websites/backend/contents/save`, this.contentsDetailForm).then((response) => {
            this.contentsDetailLoading = false;
            if (response.data.code === 200) {
              this.contentsDetailForm = {
                title: '',
                url: '',
                content: ''
              };
              this.queryContentsList();
              this.contentsDetailVisible = false;
              this.$message({
                message: '已保存',
                type: 'success'
              });
            }
          }).catch();
        }
      })
    },
    async setCategoryPackage(d, type) {
      this.categoryPackageForm = {
        type: type,
        category_id: '',
        src: '',
        package_id: ''
      };
      this.categoryPackageLoading = true;
      this.categoryPackageVisible = true;
      await this.$axios.get(`/basic/products/packages?type=${type}`).then((response) => {
        if (response.data.code === 200) {
          this.packagesList = response.data.data
        }
      });
      this.categoryPackageTitle = '设置 ' + d.category + ' 的' + type;
      const p = this.packagesList.find(item => item.label === (type === '包装' ? d.package_type : d.sample_type));
      this.categoryPackageForm = {
        type: type,
        category_id: d.id,
        src: p ? p.src : '',
        package_id: p ? p.value : ''
      };
      this.categoryPackageLoading = false;
    },
    categoryPackageSelected(selectedValue) {
      this.categoryPackagePreviewLoading = true;
      const selectedItem = this.packagesList.find(item => item.value === selectedValue);
      if (selectedItem) {
        this.categoryPackageForm.src = selectedItem.src;
      } else {
        this.categoryPackageForm.src = '';
      }
      this.categoryPackagePreviewLoading = false;
    },
    saveCategoryPackage() {
      this.categoryPackageLoading = true;
      this.$axios.post(`/websites/backend/products/categories_package_save`, this.categoryPackageForm).then((response) => {
        if (response.data.code === 200) {
          this.manageProductsCategories();
          this.categoryPackageLoading = false;
          this.$message({
            message: '已保存',
            type: 'success'
          });
        }
      }).catch();
    },
    redoProductPackages() {
      this.redoProductPackagesForm.checkedTypes = [];
      this.redoProductPackagesForm.checkAll = false;
      this.redoProductPackagesForm.isIndeterminate = false;
      this.redoProductPackagesVisible = true;
    },
    redoProductPackagesFormCheckAll(val) {
      this.redoProductPackagesForm.checkedTypes = val ? this.redoProductPackagesForm.packageTypes : [];
      this.redoProductPackagesForm.isIndeterminate = false;
    },
    redoProductPackagesFormChange(value) {
      let checkedCount = value.length;
      this.redoProductPackagesForm.checkAll = checkedCount === this.redoProductPackagesForm.packageTypes.length;
      this.redoProductPackagesForm.isIndeterminate = checkedCount > 0 && checkedCount < this.redoProductPackagesForm.packageTypes.length;
    },
    saveRedoProductPackages() {
      this.redoProductPackagesLoading = true;
      this.$axios.post(`/websites/backend/products/categories_package_redo`, {
        domain: this.domain,
        types: this.redoProductPackagesForm.checkedTypes
      }).then((response) => {
        this.redoProductPackagesLoading = false;
        if (response.data.code === 200) {
          this.redoProductPackagesVisible = false;
          this.$notify({
            title: '操作成功',
            message: '产品图已经进入重制队列',
            type: 'success'
          });
        }
      }).catch();
    },
    async queryDeploy() {
      this.deployInfo = {
        'expire_date': '',
        'dns_status': '',
        'tencent_balance': '',
        'aliyun_balance': ''
      }
      this.loading = true;
      this.deployList = [];
      await this.$axios.get(`/websites/backend/deploy/check?domain=${this.domain}`).then((response) => {
        this.loading = false;
        if (response.data.code === 200) {
          this.deployInfo = response.data.data.deploy_info;
          this.deployList = response.data.data.deploy_list;
        }
      });
    },
    addToDnspod() {
      const routeUrl = this.$router.resolve({
        name: 'websites_dnspod'
      });
      window.open(routeUrl.href, '_blank');
    },
    onSelectionChange(selection) {
      const newSet = new Set(selection.map(r => r.id));
      this.selectedIdSet = newSet;
      this.deployForm.items = this.deployForm.items.filter(it => newSet.has(it.id));
      selection.forEach(row => {
        const exists = this.deployForm.items.some(it => it.id === row.id)
        if (!exists) {
          this.deployForm.items.push(this.buildPayloadFromRow(row));
        } else {
          this.syncSelectedRowToForm(row);
        }
      })
    },
    rowSelectable(row, index) {
      return !['已提交', '已完成'].includes(row.status)
    },
    onRowOptionChanged(row) {
      if (!this.selectedIdSet.has(row.id)) return;
      this.syncSelectedRowToForm(row);
    },
    syncSelectedRowToForm(row) {
      const idx = this.deployForm.items.findIndex(it => it.id === row.id);
      if (idx === -1) return;
      this.$set(this.deployForm.items, idx, this.buildPayloadFromRow(row));
    },
    buildPayloadFromRow(row) {
      return {
        id: row.id,
        subdomain: row.subdomain,
        source_address: row.source_address,
        ssl: !!row.ssl,
        area: row.area
      }
    },
    async submitDeploy() {
      if (this.deployForm.items.length < 1) {
        this.$message({
          message: '未选中任何一条',
          type: 'error'
        });
        return false;
      }
      this.loading = true;
      await this.$axios.post(`/websites/backend/deploy/submit`, {
        domain: this.domain,
        list: this.deployForm.items
      }).then((response) => {
        this.loading = false;
        if (response.data.code === 200) {
          this.queryDeploy();
          this.$notify({
            title: '操作成功',
            message: '部署清单已提交',
            type: 'success'
          });
        }
      }).catch();
    },
    queryInternalLinkList(search = false) {
      this.internalLinkLoading = true;
      let current_page = search === true ? 1 : this.internalLinkPage;
      let keywords = this.internalLinkKeywords;
      let size = this.internalLinkSize;
      this.$axios.get('/websites/backend/internal_links', {
        params: {
          domain: this.domain,
          keywords: keywords,
          page: current_page,
          size: size
        }
      }).then((response) => {
        this.internalLinkLoading = false;
        if (response.data.code === 200) {
          this.internalLinkList = response.data.data.data;
          this.internalLinkTotal = response.data.data.total;
        }
      })
    },
    changeInternalLinkSize(val) {
      this.internalLinkSize = val;
      this.queryInternalLinkList();
    },
    currentInternalLinkChange(val) {
      this.internalLinkPage = val;
      this.queryInternalLinkList();
    },
    addInternalLink() {
      this.internalLinkDetailForm = {
        id: '',
        domain: this.domain,
        keyword: ''
      };
      this.internalLinkDetailVisible = true;
    },
    getInternalLinkDetail(row) {
      this.internalLinkDetailVisible = true;
      this.internalLinkDetailLoading = true;
      this.internalLinksDetailTitle = '编辑';
      this.$axios.get(`/websites/backend/internal_links/detail?id=${row.id}&type=${this.internalLinkType}`).then((response) => {
        this.internalLinkDetailLoading = false;
        if (response.data.code === 200) {
          this.internalLinkDetailForm = response.data.data;
        }
      })
    },
    deleteInternalLink(row) {
      this.$confirm('确定删除吗? 此操作不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/internal_links/delete', {
          id: row.id
        }).then((response) => {
          if (response.data.code === 200) {
            this.queryInternalLinkList();
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          }
        })
      }).catch(() => { });
    },
    saveInternalLinkDetail() {
      this.$refs.internalLinkDetailForm.validate(valid => {
        if (valid) {
          this.$axios.post(`/websites/backend/internal_links/save`, this.internalLinkDetailForm).then((response) => {
            this.internalLinkDetailLoading = false;
            if (response.data.code === 200) {
              this.internalLinkDetailForm = {
                id: '',
                domain: this.domain,
                keyword: ''
              };
              this.queryInternalLinkList();
              this.internalLinkDetailVisible = false;
              this.$message({
                message: '已保存',
                type: 'success'
              });
            }
          }).catch();
        }
      })
    },
    uploadInternalLink() {
      this.uploadInternalLinkFileList = [];
      this.uploadInternalLinkVisible = true;
    },
    submitUploadInternalLink() {
      this.uploadInternalLinkLoading = true;
      this.$refs.uploadInternalLink.submit();
    },
    uploadInternalLinkSuccess(response) {
      this.uploadInternalLinkFileList = [];
      if (response.code === 200) {
        this.uploadInternalLinkLoading = false;
        this.uploadInternalLinkVisible = false;
        this.$notify({
          title: 'success',
          message: '上传成功',
          type: 'success'
        })
        this.queryInternalLinkList();
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    toggleInternalLinkEnabled(row, index) {
      let notice = row.enabled ? '确定激活吗?' : '禁用后本站此内链将全部失效, 确定吗?';
      let message = row.enabled ? '激活' : '禁用';
      this.$confirm(notice, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/internal_links/toggle_enabled', {
          id: row.id,
          enabled: row.enabled
        }).then((response) => {
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: row.keyword + ' 已经' + message,
              type: 'success'
            });
          }
        })
      }).catch(() => {
        this.internalLinkList[index].enabled = !row.enabled;
      });
    }
  }
}
</script>

<style scoped>
.website-status {
  margin-left: 20px;
}

.website-blades-box {
  display: grid;
  grid-template-columns: repeat(6, minmax(200px, 1fr));
  gap: 20px;
}

.website-blades-box /deep/ .el-card {
  width: 235px;
  height: 320px;
}

.website-blades-box /deep/ .el-card .el-card__body {
  padding: 0px;
}

.website-blades-box /deep/ .el-card .image {
  width: 235px;
  height: 235px;
}

.website-media-image-box .media-image-box {
  position: relative;
  width: 100px;
  height: 120px;
  float: left;
  margin-left: 20px;
  margin: 10px 5px;
  background: #FFF;
}

.media-image-title {
  display: block;
  width: 100%;
  text-align: center;
  overflow: hidden;
  color: #333;
}

.image-rename-btn {
  position: absolute;
  top: 3px;
  left: 3px;
  color: #F00;
  display: none;
}

.image-delete-btn {
  position: absolute;
  top: 3px;
  right: 3px;
  color: #F00;
  display: none;
}

.website-media-image-box .media-image-box:hover>.image-rename-btn {
  display: block;
}

.website-media-image-box .media-image-box:hover>.image-delete-btn {
  display: block;
}

.image-rename-btn:hover,
.image-delete-btn:hover {
  color: #2486D4;
  cursor: pointer;
}

.website-media-image-box .el-image,
.website-media-image-box video {
  width: 100px;
  height: 100px;
  border: solid 1px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  transition: all ease-in-out 300ms;
}

.website-media-image-box .el-image:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}

.editor-box {
  width: 100%;
  height: 300px;
}

.editor-box /deep/ .ql-toolbar.ql-snow {
  padding: 0px;
}

.editor-box /deep/ .ql-snow.ql-toolbar button,
.ql-snow .ql-toolbar button {
  width: 20px;
}

.editor-box /deep/ .ql-editor {
  min-height: 250px;
  max-height: 250px;
}

.seo-card-box {
  display: flex;
}

.seo-card {
  width: 580px;
  margin-right: 15px;
}

.el-dialog .el-dialog__body {
  max-height: 300px;
  overflow-y: auto;
}

.seo-card /deep/ .el-table .success-row {
  background: #f0f9eb;
}

.logo-setting-current-box {
  display: flex;
}

.logo-setting-current-box .block {
  display: flex;
  flex-direction: column;
  margin-right: 40px;
  justify-content: space-between;
}

.logo-setting-current-box .block .demonstration {
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
}

.logo-upload-box {
  display: flex;
}

.logo-upload-box .upload-button {
  margin-right: 20px;
}

.others-card {
  width: 100%;
}

.pointer:hover {
  cursor: pointer;
  color: red;
}

.el-image /deep/ .image-error {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 120px;
  color: #909399;
  font-size: 14px;
  background-color: #f5f7fa;
  text-align: center;
  line-height: 1;
}

.supplements-progress-box {
  min-width: 150px;
  height: 40px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.supplements-progress-box-text {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  font-size: 14px;
}

.supplements-progress /deep/ .el-progress__text {
  font-size: 12px !important;
}

.product-detail-modal /deep/ .el-dialog__body {
  height: 68vh !important;
  overflow-y: auto;
}

/* 绿色常亮 */
.status-green {
  color: #00d000;
}

/* 红色闪烁 */
.status-red {
  color: #ff3b3b;
  animation: blink 2s infinite;
}

/* 红点闪烁动画 */
@keyframes blink {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.2;
  }
}

/deep/ .el-table th.el-table__cell>.cell {
  padding: 0 14px !important;
}

.hover-icon-table .hover-icon {
  display: none;
}

.hover-icon-table .el-table__row:hover .hover-icon {
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/Modules/Websites/Detail.vue